{
  "imageUpload": {
    "preparing": "Preparazione dell'immagine…",
    "uploading": "Caricamento dell'immagine…",
    "retrying": "Nuovo tentativo di caricamento…",
    "failed": "Impossibile caricare l'immagine",
    "failedTooLarge": "L'immagine è troppo grande",
    "failedUnsupported": "Formato immagine non supportato",
    "failedNetwork": "Impossibile raggiungere il server",
    "failedPrepare": "Impossibile elaborare l'immagine",
    "retry": "Riprova",
    "pendingWarning": "{{count}} immagine/i esistono solo in questo browser e non sono state salvate sul server. Andranno perse se chiudi o ricarichi la pagina."
  },
  "super": {
    "title": "Amministrazione",
    "issuesTitle": "Segnalazioni e idee",
    "issuesSubtitle": "Controlla le segnalazioni e i suggerimenti inviati dagli utenti",
    "brandsTab": "Marchi",
    "brandsTitle": "Marchi e distributori",
    "brandsSubtitle": "Chi ci porta ogni cliente e cosa vede all'accesso"
  },
  "radiologyStyle": {
    "title": "Il tuo stile radiologico",
    "description": "Crea un elenco con le tue preferenze su come ti piace redigere i referti. Ad esempio: «Voglio che tutti i riscontri siano in grassetto».",
    "menuLabel": "Il tuo stile radiologico",
    "settingsTitle": "Il tuo stile radiologico",
    "settingsDescription": "Definisci come ti piace redigere i referti con un elenco di preferenze personali",
    "settingsText": "Crea e modifica il tuo elenco di preferenze di stile. Ad esempio: «Voglio che tutti i riscontri siano in grassetto».",
    "settingsButton": "Modifica il mio stile",
    "empty": "Non hai ancora aggiunto alcuna preferenza di stile.",
    "placeholder": "Es: Voglio che tutti i riscontri siano in grassetto",
    "addRule": "Aggiungi preferenza",
    "removeRule": "Rimuovi preferenza",
    "saving": "Salvataggio…",
    "saved": "Il tuo stile radiologico è stato salvato correttamente",
    "saveError": "Impossibile salvare il tuo stile radiologico",
    "limitHint": "Fino a {{maxRules}} preferenze di {{maxLength}} caratteri ciascuna.",
    "maxRulesReached": "Hai raggiunto il massimo di {{maxRules}} preferenze",
    "ruleTooLong": "Una preferenza supera i {{maxLength}} caratteri: accorciala per salvare"
  },
  "common": {
    "welcome": "Benvenuto",
    "unknownModality": "Modalità sconosciuta",
    "unknownRegion": "Regione sconosciuta",
    "professionalTitleDefault": "Dott.",
    "login": "Accedi",
    "logout": "Esci",
    "save": "Salva",
    "cancel": "Annulla",
    "delete": "Elimina",
    "edit": "Modifica",
    "view": "Visualizza",
    "close": "Chiudi",
    "search": "Cerca",
    "loading": "Caricamento...",
    "sending": "Invio in corso...",
    "error": "Errore",
    "success": "Successo",
    "email": "Email",
    "password": "Password",
    "submit": "Invia",
    "back": "Indietro",
    "continue": "Continua",
    "next": "Avanti",
    "previous": "Precedente",
    "confirm": "Conferma",
    "yes": "Sì",
    "no": "No",
    "goHome": "Vai alla home",
    "home": "Home",
    "myInsights": "Le mie statistiche",
    "groupReports": "Cronologia di lavoro",
    "createReport": "Crea report",
    "templates": "Modelli",
    "accounts": "Account",
    "users": "Utenti",
    "issues": "Problemi",
    "adminPanel": "Pannello admin",
    "orgAdmin": "Organizzazione",
    "configuration": "Impostazioni",
    "parameters": "Parametri",
    "openMenu": "Apri menu",
    "collapseMenu": "Riduci menu",
    "expandMenu": "Espandi menu",
    "writeHere": "Scrivi qui...",
    "headingPlaceholder": "Titolo",
    "selectButtonsToExport": "Seleziona pulsanti da esportare",
    "exportSelection": "Esporta selezione",
    "configureButtons": "Configura pulsanti da esportare",
    "searchPlaceholder": "Cerca...",
    "clearSelection": "Cancella selezione",
    "noResults": "Nessun risultato trovato",
    "commands": "Comandi",
    "insert": "Inserisci",
    "update": "Aggiorna",
    "generate": "Genera",
    "select": "Seleziona",
    "dictate": "Dettare",
    "language": "Lingua",
    "showing": "Mostrando",
    "of": "di",
    "or": "o",
    "page": "Pagina",
    "item": "elemento",
    "items": "elementi",
    "copy": "Copia",
    "clear": "Cancella",
    "share": "Condividi",
    "discard": "Scarta",
    "deleting": "Eliminazione in corso...",
    "enabled": "Attivato",
    "disabled": "Disattivato",
    "send": "Invia",
    "pause": "Pausa",
    "resume": "Riprendi",
    "showLaterality": "Mostra lateralità",
    "hideLaterality": "Nascondi lateralità",
    "laterality": {
      "left": "Sinistra",
      "right": "Destra",
      "both": "Bilaterale"
    },
    "groups": "Gruppi"
  },
  "commandPalette": {
    "searchPlaceholder": "Digita un comando...",
    "results": "Risultati",
    "searching": "Cercando...",
    "noTemplatesFound": "Nessun modello trovato",
    "suggestions": "Suggerimenti",
    "createTemplate": "Crea modello",
    "startDictation": "Inizia dettatura",
    "generateReport": "Genera report",
    "recentTemplates": "Modelli recenti",
    "errorLoadingTemplates": "Errore nel caricamento dei modelli",
    "errorSearching": "Errore nella ricerca dei modelli",
    "mustUseWithinProvider": "useCommandPalette deve essere utilizzato all'interno di CommandPaletteProvider"
  },
  "auth": {
    "welcomeHello": "Ciao,",
    "welcomeBack": "Benvenuto",
    "launchSignInNeeded": "Il tuo esame ti sta aspettando. Accedi per continuare.",
    "launchIdentityRefused": "Non è stato possibile accedere automaticamente: i dati del tuo account non corrispondono al gruppo da cui è stato avviato l'esame. Contatta il tuo amministratore. Nel frattempo puoi accedere da qui.",
    "emailLabel": "Email",
    "passwordLabel": "Password",
    "loginTitle": "Accedi ad Ainovis",
    "loginSubtitle": "Inserisci le tue credenziali per accedere",
    "forgotPassword": "Hai dimenticato la password?",
    "rememberMe": "Ricordami",
    "noAccount": "Non hai un account?",
    "signUp": "Registrati",
    "alreadyHaveAccount": "Hai già un account?",
    "signIn": "Accedi",
    "verifyEmail": "Verifica email",
    "verifyEmailText": "Abbiamo inviato un'email di verifica al tuo indirizzo",
    "resetPassword": "Reimposta password",
    "resetPasswordText": "Inserisci la tua nuova password",
    "newPassword": "Nuova password",
    "confirmPassword": "Conferma password",
    "sendResetLink": "Invia link di reimpostazione",
    "backToLogin": "Torna al login",
    "googleLogin": "Continua con Google",
    "microsoftLogin": "Continua con Microsoft",
    "orLoginWith": "Oppure accedi con",
    "authenticatingMicrosoft": "Autenticazione con Microsoft...",
    "processingAuth": "Elaborazione autenticazione...",
    "resetPasswordTitle": "Reimposta password",
    "resetPasswordDescription": "Inserisci la tua nuova password",
    "resetting": "Reimpostazione...",
    "resetPasswordButton": "Reimposta password",
    "invalidToken": "Token non valido o scaduto",
    "completeAllFields": "Per favore, completa tutti i campi",
    "passwordsDoNotMatch": "Le password non corrispondono",
    "passwordMinLength": "La password deve contenere almeno 6 caratteri",
    "passwordResetSuccess": "Password reimpostata con successo",
    "enterButton": "Entra",
    "emailPlaceholder": "Email",
    "passwordPlaceholder": "Password",
    "completeCaptcha": "Per favore, completa il captcha",
    "continueWith": "o continua con",
    "continueWithMicrosoft": "Continua con Microsoft",
    "forgotPasswordTitle": "Hai dimenticato la password?",
    "forgotPasswordDescription": "Non preoccuparti, ti invieremo le istruzioni per reimpostarla",
    "sendInstructions": "Invia istruzioni",
    "emailSentTitle": "Email inviata",
    "emailSentMessage": "Abbiamo inviato un'email a {{email}} con le istruzioni per reimpostare la password",
    "checkSpam": "Se non ricevi l'email entro pochi minuti, controlla la cartella spam"
  },
  "notFound": {
    "title": "404",
    "subtitle": "Pagina non trovata",
    "message": "Spiacenti, la pagina che stai cercando non esiste o è stata spostata"
  },
  "dashboard": {
    "title": "Pannello di Controllo",
    "reports": "referti",
    "recentReports": "I tuoi referti diagnostici recenti",
    "createReport": "Crea referto",
    "viewAll": "Vedi tutti",
    "statistics": "Statistiche",
    "totalReports": "Totale referti",
    "pendingReports": "referti in sospeso",
    "completedReports": "referti completati"
  },
  "reports": {
    "deselectAll": "Deseleziona tutti",
    "allSelected": "Tutti selezionati ({{count}})",
    "tapToSelectAll": "Seleziona tutti",
    "selectedCountHint": "· {{count}} selezionati",
    "selectedCountHint_one": "· {{count}} selezionato",
    "selectedCountHint_other": "· {{count}} selezionati",
    "signReport": "Firma",
    "signedBy": "Firmato da:",
    "licenseNumber": "N. iscrizione",
    "sendBusy": "Attendi che termini il processo in corso",
    "requestEdit": "Richiedi permesso di modifica",
    "requestEditSent": "Richiesta inviata",
    "requestEditError": "Impossibile inviare la richiesta. Riprova.",
    "editRequestToast": "{{name}} richiede il permesso di modifica.",
    "editRequestManage": "Gestisci",
    "editRequestSomeone": "Un utente",
    "title": "referti",
    "newReport": "Nuovo referto",
    "reportList": "Elenco referti",
    "reportDetails": "Dettagli referto",
    "status": "Stato",
    "createdAt": "Creato il",
    "updatedAt": "Aggiornato il",
    "createdBy": "Creato da",
    "draft": "Bozza",
    "published": "Pubblicato",
    "archived": "Archiviato",
    "noReports": "Nessun referto disponibile",
    "deleteConfirm": "Sei sicuro di voler eliminare questo referto?",
    "studyDescription": "Descrizione dello studio",
    "studyDescriptionPlaceholder": "Inserisci la descrizione dello studio...",
    "reportGeneration": "Generazione",
    "automatic": "Automatico",
    "manual": "Manuale",
    "automaticTooltip": "Genera il referto automaticamente",
    "manualTooltip": "Genera il referto dal modello selezionato",
    "reportFormat": "Tipo di referto",
    "inside": "Inside",
    "first": "First",
    "insideTooltip": "I risultati saranno distribuiti uniformemente nella sezione 'Risultati'",
    "firstTooltip": "I risultati saranno posizionati all'inizio della sezione 'Risultati'",
    "selectedTemplate": "Modello Selezionato",
    "templateList": "Elenco Modelli",
    "auto": "Auto",
    "automatic2": "Automatico",
    "enterDescription": "Per favore, inserisci una descrizione dello studio",
    "reportCopied": "referto copiato con successo",
    "reportGenerated": "referto generato con successo",
    "reportSaved": "referto salvato con successo",
    "noReportToSave": "Nessun referto generato da salvare",
    "missingReportInfo": "Informazioni del referto mancanti",
    "timeoutError": "La generazione ha richiesto troppo tempo. Prova con una descrizione più breve",
    "generateButton": "Genera referto",
    "generating": "Generazione...",
    "thinking": "Pensando...",
    "saveButton": "Salva referto",
    "saving": "Salvataggio...",
    "generatingMessage": "Generazione referto...",
    "savingMessage": "Salvataggio referto...",
    "editorPlaceholder": "Il referto generato apparirà qui...",
    "activateDictation": "Attiva dettatura vocale",
    "holdMicSendHint": "Rilascia per inviare · Esc per annullare",
    "holdMicCancelHint": "Rilascia per annullare",
    "keepAllContent": "Mantieni tutto il contenuto contrassegnato",
    "keepContentDesc": "Mantieni contenuto contrassegnato (unisci senza eliminare)",
    "deleteAllContent": "Elimina tutto il contenuto contrassegnato",
    "keepOriginal": "Mantieni testo originale",
    "keepOriginalDesc": "Mantieni il testo originale (scarta le modifiche)",
    "applyUpdates": "Applica tutti gli aggiornamenti",
    "generateReport": "Genera referto",
    "basedOnRecentActivity": "In base alla tua attività recente",
    "aiDisclaimer": "Ainovis può commettere errori. Considera di verificare le informazioni importanti",
    "reportContent": "Parametri del referto",
    "continueWithBaseTemplate": "Continua con modello base",
    "blocksDetected": "Blocchi rilevati",
    "selectBlockHint": "Seleziona un blocco o continua con il modello base",
    "continueWithNormalTemplate": "Continua senza blocchi",
    "referenceSelected": "Riferimento selezionato ✓",
    "blockSelected": "Blocco selezionato ✓",
    "blockSkipped": "Continuando senza blocco ✓",
    "description": "Descrittivo",
    "detectedProcedures": "Procedure rilevate",
    "noProceduresDetected": "Nessuna procedura rilevata",
    "detectedLaterality": "Lateralità rilevata",
    "noLateralityFound": "Nessuna lateralità trovata",
    "searchLaterality": "Allinea lateralità",
    "lateralityUpdated": "Lateralità aggiornata",
    "errorSearchingLaterality": "Errore nel rilevare la lateralità",
    "findingsFirst": "Risultati all'inizio",
    "findingsInside": "Risultati all'interno del testo",
    "welcome": "Benvenuto {{title}} {{surname}}",
    "searchTemplate": "Cerca modello...",
    "loadingTemplate": "Caricamento modello...",
    "multipleReferencesDetected": "Riferimenti multipli rilevati",
    "selectReferenceHint": "Seleziona un'opzione per continuare con la generazione",
    "generateManualReport": "Genera referto manuale",
    "blankCanvas": "Foglio bianco",
    "createTemplate": "Crea modello",
    "viewPowerBI": "Visualizza Statistiche",
    "uploadAudio": "Elaborazione audio in batch",
    "activitySummary": "Riepilogo attività",
    "viewMoreStats": "Vedi più statistiche",
    "noTemplatesFound": "Nessun modello trovato",
    "errorCreatingBlankCanvas": "Errore nella creazione del foglio bianco",
    "manualModePlaceholder": "Scrivi il modello che vuoi utilizzare",
    "navigate": "navigare",
    "select": "selezionare",
    "close": "chiudere",
    "loadingTemplates": "Caricamento modelli...",
    "searchPlaceholder": "Cerca referto...",
    "reportsHistorySidebarTitle": "Cronologia dei referti",
    "reportsHistorySidebarTitleSaved": "Referti inviati",
    "reportsHistoryPreviewStamp": "Referto inviato",
    "reportsHistorySidebarClose": "Chiudi il pannello cronologia",
    "reportsHistoryLoading": "Caricamento…",
    "reportsHistoryError": "Impossibile caricare la cronologia",
    "reportsHistoryNoResults": "Nessun risultato",
    "reportsHistoryDraftsEmpty": "Non hai bozze",
    "reportsHistorySavedEmpty": "Non hai referti inviati",
    "reportsHistoryUntitled": "Senza titolo",
    "reportsHistoryTabDrafts": "Bozze",
    "reportsHistoryTabSaved": "Inviati",
    "createReport": "Crea referto",
    "currentStatus": "Stato attuale",
    "pendingReview": "Referti in attesa di revisione",
    "savedToday": "Referti salvati oggi",
    "draftReports": "Referti in bozza",
    "recentReports": "Referti diagnostici recenti",
    "drafts": "Bozze",
    "sent": "Inviati",
    "saved": "Inviati",
    "sharedWithMe": "Condivisi con me",
    "ownedByMe": "Sono il proprietario",
    "noOwnedDrafts": "Nessuna bozza di cui sei proprietario",
    "countOwned": "{{count}} propri",
    "workHistoryTitle": "Cronologia",
    "viewGroupWorkHistory": "Vedi la cronologia di lavoro del gruppo",
    "countDrafts": "{{count}} bozze",
    "countBatches": "{{count}} lotti",
    "countSent": "{{count}} inviati",
    "countShared": "{{count}} condivisi",
    "diagnosis": "Conclusione",
    "versions": "Versioni",
    "version": "versione",
    "lastUpdate": "Ultimo aggiornamento",
    "actions": "Azioni",
    "noDrafts": "Nessuna bozza",
    "noSharedDrafts": "Nessun referto condiviso con te",
    "noDiagnosis": "(Nessuna diagnosi)",
    "loadingVersions": "Caricamento versioni...",
    "owner": "Proprietario",
    "modalities": "Modalità",
    "procedure": "Procedura",
    "procedures": "Procedure",
    "time": "Ora",
    "draftVersionsInfo": "Questa bozza ha {{count}} versione/i salvata/e",
    "report": "referto",
    "reports": "referti",
    "yourPerformance": "Le tue prestazioni",
    "last7Days": "Ultimi 7 giorni",
    "thisWeek": "Questa settimana",
    "thisMonth": "Questo mese",
    "today": "Oggi",
    "yesterday": "Ieri",
    "last30Days": "Ultimi 30 giorni",
    "older": "Precedenti",
    "totalReports": "Totale",
    "deleteDraftTitle": "Elimina bozza",
    "leaveDraft": "Abbandona bozza",
    "leaveDraftTitle": "Abbandona bozza",
    "leaveDraftConfirm": "Abbandona",
    "leaveDraftMessage": "Non avrai più accesso a questa bozza condivisa. Il proprietario potrà condividerla di nuovo con te.",
    "deleteReportTitle": "Elimina referto",
    "deleteDraftMessage": "Sei sicuro di voler eliminare questa bozza e tutte le sue versioni? Questa azione non può essere annullata.",
    "deleteReportMessage": "Sei sicuro di voler eliminare questo referto salvato? Questa azione non può essere annullata.",
    "deleteBatchTitle": "Elimina lotto",
    "deleteBatchMessage": "Sei sicuro di voler eliminare questo lotto e tutti i suoi studi? Questa azione non può essere annullata.",
    "errorLoadingReport": "Errore nel caricamento del referto",
    "noContentToCopy": "Nessun contenuto da copiare",
    "contentCopied": "Contenuto copiato negli appunti",
    "errorCopying": "Errore nella copia del contenuto",
    "errorPreSaveValidation": "Errore nella validazione prima del salvataggio",
    "preSaveInconsistencies": "Inconsistenze rilevate",
    "preSaveVersions": "Versioni multiple",
    "preSaveVersionsMsg": "Verrà salvata solo la versione attuale e le {{count}} rimanenti verranno scartate.",
    "errorSavingReport": "Errore nel salvataggio del referto",
    "errorSavingDraft": "Errore nel salvataggio della bozza",
    "draftDeleted": "Bozza eliminata con successo",
    "errorDeletingDraft": "Errore nell'eliminazione della bozza",
    "emptyTechnique": "La tecnica è vuota",
    "proceduresFound": "Procedure aggiornate",
    "errorSearchingProcedures": "Errore nella ricerca delle procedure",
    "blankVersionCreated": "Foglio bianco creato",
    "errorCreatingBlankVersion": "Errore nella creazione del foglio bianco",
    "loadingReport": "Caricamento referto...",
    "deletingMessage": "Eliminazione bozza...",
    "searchingProcedures": "Ricerca procedure...",
    "searchingLaterality": "Rilevamento lateralità...",
    "hideProcedures": "Nascondi procedure",
    "searchProcedures": "Cerca procedure",
    "showProcedures": "Mostra procedure",
    "confirmDeleteDraft": "Sei sicuro di voler eliminare questa bozza? Questa azione non può essere annullata.",
    "inconsistency": "Inconsistenza",
    "show": "Mostra",
    "preSaveTitle": "Prima di salvare",
    "preSaveSubtitle": "Sono state rilevate le seguenti avvertenze:",
    "confirmSave": "Invia comunque",
    "unsavedChanges": "Modifiche non salvate",
    "unsavedChangesMessage": "\"{{title}}\" ha modifiche non salvate. Scartare le modifiche?",
    "maxVersionsReached": "Numero massimo di referti raggiunto",
    "settings": "Configurazione",
    "reportType": "Tipo di referto",
    "noTemplateSelected": "Rilevamento automatico",
    "useAnotherTemplate": "Usa un altro modello",
    "change": "Cambia",
    "changeTemplate": "Cambia modello",
    "backToAutoDetection": "Torna al rilevamento automatico",
    "autoDetection": "Rilevamento automatico",
    "noDescription": "Senza descrizione",
    "resume": "Riprendi",
    "pause": "Pausa",
    "process": "Elabora",
    "processingAudio": "Elaborazione audio...",
    "analyzingVoice": "Analisi della voce...",
    "transcribingAudio": "Trascrizione audio...",
    "interpretingCommands": "Interpretazione comandi...",
    "preparingResult": "Preparazione risultato...",
    "analyzingText": "Analisi del testo...",
    "understandingIntent": "Comprensione dell'intento...",
    "readingContext": "Lettura del contesto...",
    "identifyingSections": "Identificazione delle sezioni...",
    "writing": "Scrittura...",
    "fillingReport": "Compilazione del referto...",
    "writingSections": "Redazione delle sezioni...",
    "addingFindings": "Aggiunta dei reperti...",
    "refiningContent": "Perfezionamento del contenuto...",
    "applyingClassifications": "Applicazione classificazioni...",
    "evaluatingCriteria": "Valutazione criteri...",
    "calculatingResults": "Calcolo risultati...",
    "finalizingReport": "Finalizzazione...",
    "aiAssistantPlaceholder": "Scrivi un testo o detta con il microfono...",
    "sendToDescriptive": "Al descrittivo",
    "aiChatEmpty": "Invia un messaggio per iniziare la conversazione",
    "carolinaAssistance": "Carolina Assistance",
    "send": "Invia",
    "record": "Registra",
    "generate": "Genera",
    "selectReference": "Seleziona uno dei riferimenti per continuare",
    "errorGenerating": "Errore nella generazione del referto",
    "noTemplateDetected": "Nessun modello rilevato",
    "reportGeneratedWithReference": "Referto generato con il riferimento selezionato",
    "versionCreated": "Nuova versione creata con successo",
    "errorCreatingVersion": "Errore nella creazione della versione",
    "emptyRecording": "La registrazione è vuota",
    "invalidServerResponse": "Errore: risposta del server non valida",
    "noAudioDetected": "Nessun audio rilevato",
    "commandExecuted": "Comando eseguito con successo",
    "audioTranscribed": "Audio trascritto con successo",
    "audioProcessingError": "Errore nell'elaborazione dell'audio",
    "microphoneAccessError": "Impossibile accedere al microfono",
    "descriptionRequired": "Devi inserire una descrizione",
    "errorLoadingTemplates": "Impossibile caricare i modelli",
    "patient": "Paziente",
    "patientId": "ID Paziente",
    "patientIdPlaceholder": "ID...",
    "patientAge": "Età",
    "patientAgePlaceholder": "Anni",
    "patientSex": "Sesso",
    "patientSexPlaceholder": "Seleziona...",
    "sexMale": "Maschile",
    "sexFemale": "Femminile",
    "studyDate": "Data dello studio",
    "requestReason": "Motivo della richiesta",
    "patientNamePlaceholder": "Cognome, Nome",
    "requestReasonPlaceholder": "Descrizione del motivo...",
    "cancel": "Annulla",
    "cancelEditing": "Annulla modifica",
    "patientNameRequired": "Il nome del paziente è obbligatorio",
    "confirmHint": "Invio per confermare · Esc per annullare",
    "editPatient": "Modifica paziente",
    "deletePatient": "Elimina paziente",
    "contractReason": "Comprimi motivo",
    "expandReason": "Espandi motivo",
    "years": "Anni",
    "modality": "Modalità",
    "accessionNumber": "N. Accesso",
    "referringPhysician": "Medico richiedente",
    "previousStudiesTitle": "Studi Precedenti",
    "previousStudiesHint": "Consulta e confronta con studi precedenti del paziente",
    "allProcedures": "Tutte le procedure",
    "study": "studio",
    "studiesCount": "studi",
    "studyPlural": "studi",
    "batches": "Lotti",
    "batchStudies": "Studi",
    "noBatches": "Nessun lotto in sospeso",
    "continueBatch": "Continua",
    "noStudiesFound": "Nessuno studio precedente trovato",
    "studyStatus_completed": "Completato",
    "studyStatus_pending": "In attesa",
    "studyStatus_cancelled": "Annullato",
    "loadPrevStudies": "Carica studi precedenti",
    "reportClinicalInfo": "Informazioni cliniche",
    "reportTechnique": "Tecnica",
    "reportFindings": "Reperti",
    "reportConclusion": "Conclusione",
    "conclusionType": "Conclusione",
    "conclusionBrief": "Conclusione breve",
    "conclusionNormal": "Conclusione normale",
    "conclusionExtensive": "Conclusione estesa",
    "conclusionBriefShort": "Breve",
    "conclusionNormalShort": "Normale",
    "conclusionExtensiveShort": "Estesa",
    "speedMode": "Modalità di velocità",
    "fast": "Veloce",
    "accurate": "Preciso",
    "fastModeDesc": "Generazione rapida",
    "accurateModeDesc": "Maggiore precisione",
    "loadTemplate": "Carica referto senza modifiche",
    "templateNotes": "Vuoi modificare qualcosa nella generazione del nuovo referto?",
    "templateNotesPlaceholder": "Es.: Modificare i reperti del fegato, aggiungere nodulo polmonare di 8mm…",
    "needDescriptive": "Scrivi qualcosa nel campo di testo per poter generare",
    "useAsTemplate": "Genera usando questo come modello",
    "noReportContent": "Nessun contenuto del referto disponibile",
    "searchStudies": "Cerca per procedura o data…",
    "previousStudy": "Studio precedente",
    "makeChanges": "Apporta modifiche",
    "makeChangesPlaceholder": "Descrivi le modifiche che desideri apportare al referto comparativo…",
    "classificationSectionsEmpty": "Le sezioni tecnica, reperti e conclusione devono essere complete per classificare",
    "classificationSuccess": "Classificazione completata con successo",
    "classificationError": "Errore durante la classificazione",
    "editorNotReady": "L'editor non è pronto",
    "classificationUnchanged": "Il contenuto del referto non è cambiato dall'ultima classificazione.",
    "classificationNoFindings": "Non sono stati trovati reperti compatibili per questa classificazione",
    "classificationInResearch": "Questa funzionalità è in fase di ricerca. Se desideri utilizzarla, richiedila al tuo amministratore.",
    "classifications": "Classificazioni",
    "classificationsTitle": "Classificazioni",
    "fleischnerClassification": "Classificazione di Fleischner",
    "fleischnerDesc": "Noduli polmonari incidentali — Fleischner 2017",
    "analyzing": "Analisi in corso…",
    "classify": "Classifica",
    "results": "Risultati",
    "table": "Tabella",
    "fleischnerCriteria": "Criteri di Fleischner",
    "fleischner_toggleHighlight": "Mostra/nascondi evidenziazione",
    "fleischnerDescription": "Linee guida per il follow-up dei noduli polmonari incidentali rilevati alla TC, in base a dimensione, numero e tipo di nodulo.",
    "singleSolidNodule": "Nodulo solido singolo",
    "multipleSolidNodules": "Noduli solidi multipli",
    "subsolidNodules": "Noduli subsolidi",
    "pureGroundGlass": "Vetro smerigliato puro",
    "partSolidNodule": "Nodulo parzialmente solido",
    "size": "Dimensione",
    "lowRisk": "Basso rischio",
    "highRisk": "Alto rischio",
    "followUp": "Follow-up",
    "noFollowUp": "Nessun follow-up",
    "partSolidNote": "Se la parte solida ≥ 6 mm, considerare PET-TC o resezione.",
    "reference": "Riferimento: MacMahon H et al.",
    "singleLt6LowRisk": "Nessun follow-up",
    "singleLt6HighRisk": "TC a 12 mesi (opzionale)",
    "single6to8LowRisk": "TC a 6–12 mesi → considerare a 18–24 mesi",
    "single6to8HighRisk": "TC a 6–12 mesi → ripetere a 18–24 mesi",
    "singleGt8LowRisk": "Considerare TC a 3 mesi, PET-TC o biopsia",
    "singleGt8HighRisk": "Come basso rischio",
    "multipleLt6LowRisk": "Nessun follow-up",
    "multipleLt6HighRisk": "TC a 12 mesi",
    "multipleGte6LowRisk": "TC a 3–6 mesi → considerare a 18–24 mesi",
    "multipleGte6HighRisk": "TC a 3–6 mesi → ripetere a 18–24 mesi",
    "ggLt6": "Nessun follow-up",
    "ggGte6": "TC a 6–12 mesi → poi ogni 2 anni fino a 5 anni",
    "psLt6": "Nessun follow-up",
    "psGte6": "TC a 3–6 mesi → se persiste, follow-up annuale per 5 anni",
    "conclusionNoFollowUp": "Non richiede follow-up secondo i criteri di Fleischner 2017.",
    "conclusionOptionalCT12": "Si raccomanda controllo opzionale con TC a 12 mesi secondo i criteri di Fleischner 2017.",
    "conclusionCT6to12Consider18to24": "Si raccomanda controllo con TC a 6-12 mesi, considerando follow-up aggiuntivo a 18-24 mesi secondo i criteri di Fleischner 2017.",
    "conclusionCT6to12Repeat18to24": "Si raccomanda controllo con TC a 6-12 mesi, con follow-up aggiuntivo a 18-24 mesi secondo i criteri di Fleischner 2017.",
    "conclusionConsiderCT3PetBiopsy": "Si raccomanda di considerare TC a 3 mesi, PET-TC o biopsia secondo i criteri di Fleischner 2017.",
    "conclusionCT12": "Si raccomanda controllo con TC a 12 mesi secondo i criteri di Fleischner 2017.",
    "conclusionCT3to6Consider18to24": "Si raccomanda controllo con TC a 3-6 mesi, considerando follow-up aggiuntivo a 18-24 mesi secondo i criteri di Fleischner 2017.",
    "conclusionCT3to6Repeat18to24": "Si raccomanda controllo con TC a 3-6 mesi, con follow-up aggiuntivo a 18-24 mesi secondo i criteri di Fleischner 2017.",
    "conclusionCT6to12Every2y5y": "Si raccomanda controllo con TC a 6-12 mesi, seguito da controlli ogni 2 anni fino a 5 anni secondo i criteri di Fleischner 2017.",
    "conclusionCT3to6Annual5y": "Si raccomanda controllo con TC a 3-6 mesi e, se persiste, follow-up annuale per 5 anni secondo i criteri di Fleischner 2017.",
    "tirads_classification": "Classificazione TI-RADS",
    "tirads_desc": "Noduli tiroidei — ACR TI-RADS 2017",
    "tirads_criteria": "Criteri ACR TI-RADS",
    "tirads_description": "Sistema di punteggio per noduli tiroidei rilevati tramite ecografia, basato su composizione, ecogenicità, forma, margini e foci ecogeni.",
    "tirads_composition": "Composizione",
    "tirads_echogenicity": "Ecogenicità",
    "tirads_shape": "Forma",
    "tirads_margin": "Margini",
    "tirads_echogenicFoci": "Foci Ecogeni",
    "tirads_feature": "Caratteristica",
    "tirads_points": "Punti",
    "tirads_compositionCystic": "Cistico o quasi completamente cistico",
    "tirads_compositionSpongiform": "Spongiforme",
    "tirads_compositionMixed": "Misto cistico e solido",
    "tirads_compositionSolid": "Solido o quasi completamente solido",
    "tirads_echogenicityAnechoic": "Anecogeno",
    "tirads_echogenicityHyperIso": "Iperecogeno o isoecogeno",
    "tirads_echogenicityHypo": "Ipoecogeno",
    "tirads_echogenicityVeryHypo": "Molto ipoecogeno",
    "tirads_shapeWider": "Più largo che alto",
    "tirads_shapeTaller": "Più alto che largo",
    "tirads_marginSmooth": "Liscio",
    "tirads_marginIllDefined": "Mal definito",
    "tirads_marginLobulated": "Lobulato o irregolare",
    "tirads_marginExtrathyroidal": "Estensione extratiroidea",
    "tirads_fociNone": "Nessuno o artefatti a coda di cometa grandi",
    "tirads_fociMacro": "Macrocalcificazioni",
    "tirads_fociPeripheral": "Calcificazioni periferiche (ad anello)",
    "tirads_fociPunctate": "Foci ecogeni puntiformi",
    "tirads_categoriesTitle": "Categorie e raccomandazioni",
    "tirads_categoryCol": "Categoria",
    "tirads_fnaThreshold": "FNAB se",
    "tirads_followUpThreshold": "Follow-up se",
    "tirads_tr1_name": "TR1 — Benigno",
    "tirads_tr2_name": "TR2 — Non sospetto",
    "tirads_tr3_name": "TR3 — Lievemente sospetto",
    "tirads_tr4_name": "TR4 — Moderatamente sospetto",
    "tirads_tr5_name": "TR5 — Altamente sospetto",
    "tirads_scoringNote": "Sommare i punti di ciascuna categoria (valore più alto di ciascuna). Si applica solo a noduli ≥ 1 cm o con caratteristiche sospette.",
    "tirads_reference": "Riferimento: Tessler FN et al.",
    "tirads_conclusionTR1": "Nodulo tiroideo classificato come TI-RADS 1 (benigno). Non richiede FNAB né follow-up secondo ACR TI-RADS 2017.",
    "tirads_conclusionTR2": "Nodulo tiroideo classificato come TI-RADS 2 (non sospetto). Non richiede FNAB né follow-up secondo ACR TI-RADS 2017.",
    "tirads_conclusionTR3": "Nodulo tiroideo classificato come TI-RADS 3 (lievemente sospetto). Si raccomanda FNAB se ≥ 2.5 cm o follow-up se ≥ 1.5 cm secondo ACR TI-RADS 2017.",
    "tirads_conclusionTR4": "Nodulo tiroideo classificato come TI-RADS 4 (moderatamente sospetto). Si raccomanda FNAB se ≥ 1.5 cm o follow-up se ≥ 1 cm secondo ACR TI-RADS 2017.",
    "tirads_conclusionTR5": "Nodulo tiroideo classificato come TI-RADS 5 (altamente sospetto). Si raccomanda FNAB se ≥ 1 cm o follow-up se ≥ 0.5 cm secondo ACR TI-RADS 2017.",
    "tirads_chooseOne": "Scegliere 1",
    "tirads_chooseAll": "Tutti quelli che si applicano",
    "tirads_sumPoints": "Sommare i punti di tutte le categorie",
    "tirads_selectOptions": "Seleziona opzioni",
    "tirads_recommendationCol": "Raccomandazione",
    "tirads_noFnaNoFollowUp": "No FNAB · No follow-up",
    "tirads_tr1_label": "Benigno",
    "tirads_tr2_label": "Non sospetto",
    "tirads_tr3_label": "Lievemente sospetto",
    "tirads_tr4_label": "Moderatamente sospetto",
    "tirads_tr5_label": "Altamente sospetto",
    "bosniak_classification": "Classificazione Bosniak 2019",
    "bosniak_desc": "Masse renali cistiche — Bosniak 2019",
    "bosniak_criteria": "Criteri Bosniak 2019",
    "bosniak_description": "Sistema di classificazione per masse renali cistiche basato su caratteristiche di parete, setti, potenziamento, calcificazione, nodularità e attenuazione su TC/RM.",
    "bosniak_wall": "Parete",
    "bosniak_septa": "Setti",
    "bosniak_enhancement": "Potenziamento",
    "bosniak_calcification": "Calcificazione",
    "bosniak_attenuation": "Attenuazione / Segnale",
    "bosniak_chooseOne": "Scegliere 1",
    "bosniak_highestCategory": "La categoria più alta determina la classificazione",
    "bosniak_selectFeatures": "Seleziona le caratteristiche",
    "bosniak_malignancyRisk": "Rischio di malignità",
    "bosniak_wallThinSmooth": "Parete sottile (≤ 2 mm) liscia",
    "bosniak_wallThinSmoothWithSepta": "Parete sottile (≤ 2 mm) liscia (con setti o calcificazione)",
    "bosniak_wallMinimalThickening3mm": "Ispessimento minimo liscio (3 mm) con potenziamento",
    "bosniak_wallThickOrIrregular": "Parete spessa (≥ 4 mm) o irregolare con potenziamento",
    "bosniak_wallWithNodule": "Parete con nodulo/i con potenziamento",
    "bosniak_septaNone": "Senza setti",
    "bosniak_septaFewThin": "Pochi (1–3) setti sottili (≤ 2 mm) con potenziamento",
    "bosniak_septaMinimalThickeningOrMany": "Ispessimento minimo (3 mm) dei setti o ≥ 4 setti sottili",
    "bosniak_septaThickOrIrregular": "Setti spessi (≥ 4 mm) o irregolari con potenziamento",
    "bosniak_septaWithNodule": "Setti con nodulo/i (≥ 4 mm ottuso o qualsiasi angolo acuto)",
    "bosniak_enhanceWallOnly": "La parete può mostrare potenziamento; nessun potenziamento interno",
    "bosniak_enhanceSeptaWall": "Setti e parete possono mostrare potenziamento",
    "bosniak_enhanceSmoothMinimal": "Potenziamento liscio di parete o setti (3 mm)",
    "bosniak_enhanceThickIrregular": "Potenziamento di parete o setti spessi/irregolari",
    "bosniak_enhanceNodular": "Componente/i nodulare/i con potenziamento",
    "bosniak_calcNone": "Senza calcificazione",
    "bosniak_calcAnyType": "Calcificazione di qualsiasi tipo (parete sottile, pochi setti)",
    "bosniak_attenSimpleFluid": "Liquido semplice omogeneo (−9 a 20 UH)",
    "bosniak_attenHyperNonContrast": "Iperatenuante omogeneo (≥ 70 UH) TC senza contrasto",
    "bosniak_attenNonEnhancingGt20": "Omogeneo senza potenziamento > 20 UH (protocollo renale TC)",
    "bosniak_attenPortalVenous2130": "Omogeneo 21–30 UH in fase portale venosa",
    "bosniak_attenTooSmall": "Omogeneo a bassa attenuazione, troppo piccolo per caratterizzare",
    "bosniak_attenHeteroT1Hyper": "Eterogeneo in T1 senza contrasto con saturazione del grasso (iperintenso)",
    "bosniak_bI_label": "Benigno",
    "bosniak_bII_label": "Minimamente complesso",
    "bosniak_bIIF_label": "Minimamente complesso (follow-up)",
    "bosniak_bIII_label": "Indeterminato",
    "bosniak_bIV_label": "Chiaramente maligno",
    "bosniak_scoringNote": "La categoria Bosniak finale è determinata dalla caratteristica di grado più elevato. Non applicare a lesioni con > 25% di componente solida, eziologia infettiva/infiammatoria o vascolare.",
    "bosniak_reference": "Riferimento: Silverman SG et al.",
    "bosniak_conclusionI": "Massa renale cistica classificata come Bosniak I (benigna). Non necessita di follow-up secondo la classificazione Bosniak 2019.",
    "bosniak_conclusionII": "Massa renale cistica classificata come Bosniak II (minimamente complessa, benigna). Rischio di malignità < 1%. Non necessita di follow-up secondo la classificazione Bosniak 2019.",
    "bosniak_conclusionIIF": "Massa renale cistica classificata come Bosniak IIF (minimamente complessa, necessita follow-up). Rischio di malignità 5–10%. Si raccomanda follow-up con imaging secondo la classificazione Bosniak 2019.",
    "bosniak_conclusionIII": "Massa renale cistica classificata come Bosniak III (indeterminata). Rischio di malignità ~50%. Si raccomanda chirurgia o sorveglianza attiva secondo il contesto clinico e la classificazione Bosniak 2019.",
    "bosniak_conclusionIV": "Massa renale cistica classificata come Bosniak IV (chiaramente maligna). Rischio di malignità ~90%. Si raccomanda trattamento chirurgico secondo la classificazione Bosniak 2019.",
    "bosniak_tabScoring": "Calcolatrice",
    "bosniak_tabCategories": "Categorie",
    "bosniak_tabImaging": "Imaging",
    "bosniak_tabInfo": "Info",
    "bosniak_wallDesc": "Valutazione dello spessore, regolarità e presenza di noduli nella parete della cisti renale. L'ispessimento o l'irregolarità della parete aumenta la categoria Bosniak.",
    "bosniak_septaDesc": "Valutazione del numero, spessore e regolarità dei setti intracistici. I setti spessi o con noduli suggeriscono un maggiore rischio di malignità.",
    "bosniak_enhancementDesc": "Pattern di enhancement dopo somministrazione di mezzo di contrasto endovenoso. L'enhancement vero (≥ 20 UH) dei componenti solidi è fondamentale per differenziare masse benigne da maligne.",
    "bosniak_calcificationDesc": "La calcificazione da sola non modifica la categoria Bosniak nella versione 2019. Viene documentata ma non altera la classificazione.",
    "bosniak_attenuationDesc": "Caratteristiche di attenuazione (TC) o segnale (RM) del contenuto cistico. I valori di UH e il pattern di segnale determinano se la cisti è semplice o complessa.",
    "bosniak_typicalFindings": "Reperti tipici",
    "bosniak_catI_desc": "Cisti renale semplice. Parete sottile e impercettibile, contenuto omogeneo di densità acqua (−9 a 20 UH), senza setti, calcificazione né enhancement interno.",
    "bosniak_catI_finding1": "Parete sottile (≤ 2 mm), liscia, senza enhancement murale apprezzabile",
    "bosniak_catI_finding2": "Contenuto omogeneo acqua (−9 a 20 UH) senza setti",
    "bosniak_catI_finding3": "Segnale RM: iperintensa T2, ipointensa T1 senza restrizione di diffusione",
    "bosniak_catII_desc": "Cisti minimamente complessa senza enhancement sospetto. Include cisti con pochi setti sottili, calcificazione fine o contenuto iperdenso senza enhancement.",
    "bosniak_catII_finding1": "Pochi setti sottili (≤ 2 mm) che possono presentare enhancement",
    "bosniak_catII_finding2": "Calcificazione di qualsiasi tipo in parete sottile o setti sottili",
    "bosniak_catII_finding3": "Cisti iperdense ≥ 70 UH o non-enhancing > 20 UH",
    "bosniak_catIIF_desc": "Cisti minimamente complessa che richiede follow-up. Presenta caratteristiche leggermente più complesse di Bosniak II, ma senza enhancement francamente sospetto.",
    "bosniak_catIIF_finding1": "Ispessimento minimo liscio (3 mm) di parete o setti con enhancement",
    "bosniak_catIIF_finding2": "Setti sottili multipli (≥ 4) o complessità moderata",
    "bosniak_catIIF_finding3": "Segnale eterogeneo in T1 con saturazione del grasso (iperintenso)",
    "bosniak_catIII_desc": "Massa cistica indeterminata. Presenta reperti sospetti come ispessimento irregolare di parete/setti con enhancement, ma senza componente chiaramente nodulare.",
    "bosniak_catIII_finding1": "Parete o setti spessi (≥ 4 mm) o irregolari con enhancement",
    "bosniak_catIII_finding2": "Enhancement misurabile dei componenti ispessiti/irregolari",
    "bosniak_catIII_finding3": "Senza nodulo murale o settale chiaramente definito",
    "bosniak_catIV_desc": "Massa cistica chiaramente maligna. Contiene componente/i nodulare/i solido/i con enhancement, indicando carcinoma a cellule renali fino a prova contraria.",
    "bosniak_catIV_finding1": "Nodulo/i murale/i o settale/i con enhancement (componente solido)",
    "bosniak_catIV_finding2": "Margini angolati del nodulo (< 90°) con parete o setto",
    "bosniak_catIV_finding3": "Componente solido con enhancement, con restrizione di diffusione",
    "bosniak_protocolTitle": "Protocollo TC renale",
    "bosniak_phasePrecontrast": "Fase senza contrasto",
    "bosniak_phasePrecontrastDesc": "Misurare l'attenuazione basale della cisti (UH). Fondamentale per rilevare cisti iperdense e calcolare l'enhancement vero.",
    "bosniak_phaseCorticomedullary": "Fase corticomidollare",
    "bosniak_phaseCorticomedullaryDesc": "25–70 s post-iniezione. Utile per rilevare enhancement precoce, ma la fase nefrografica è preferita per Bosniak.",
    "bosniak_phaseNephrographic": "Fase nefrografica",
    "bosniak_phaseNephrographicDesc": "80–180 s post-iniezione. Fase ottimale per valutare enhancement di parete/setti. È la fase più importante per la classificazione.",
    "bosniak_phaseExcretory": "Fase escretoria",
    "bosniak_phaseExcretoryDesc": "≥ 3 min. Valutare rapporto con sistema collettore ed escludere diverticolo caliceale.",
    "bosniak_enhancementCritTitle": "Criteri di enhancement",
    "bosniak_enhanceCrit1": "Enhancement vero: incremento ≥ 20 UH tra fase senza contrasto e nefrografica",
    "bosniak_enhanceCrit2": "Pseudoenhancement: incremento < 10 UH per scatter/beam hardening, non enhancement vero",
    "bosniak_enhanceCrit3": "Zona grigia (10–20 UH): considerare RM con sottrazione per conferma",
    "bosniak_mriTitle": "Valutazione con RM",
    "bosniak_mriT1": "Pre e post-Gd con saturazione del grasso. Sottrazione obbligatoria per rilevare enhancement sottile.",
    "bosniak_mriT2": "Contenuto cistico iperintenso. I componenti solidi sono relativamente ipointensi.",
    "bosniak_mriDWI": "Utile come complemento. La restrizione di diffusione può indicare componente solido, ma non sostituisce l'enhancement.",
    "bosniak_mriSubtraction": "Sottrazione",
    "bosniak_mriSubtractionDesc": "Indispensabile in RM. Sottrae T1 pre-Gd dal T1 post-Gd per isolare enhancement vero dal segnale intrinseco T1.",
    "bosniak_pitfallsTitle": "Errori diagnostici frequenti",
    "bosniak_pitfall1": "Confondere pseudoenhancement da scatter con enhancement vero in cisti piccole (< 2 cm) adiacenti al parenchima",
    "bosniak_pitfall2": "Non misurare l'attenuazione basale senza contrasto — impossibile determinare enhancement vero senza riferimento",
    "bosniak_pitfall3": "Classificare cisti emorragiche/proteinacee (iperdense) come complesse quando NON presentano enhancement",
    "bosniak_pitfall4": "Applicare Bosniak a masse con > 25% di componente solido — la classificazione non è progettata per masse solide",
    "bosniak_changesTitle": "Modifiche Bosniak 2019 vs. precedente",
    "bosniak_change1": "Eliminazione della categoria Bosniak I vs. II basata sulla calcificazione — la calcificazione non influenza più la categoria",
    "bosniak_change2": "Nuova definizione delle soglie di spessore: ≤ 2 mm (sottile), 3 mm (minimamente ispessito), ≥ 4 mm (spesso)",
    "bosniak_change3": "Incorporazione formale della RM come modalità equivalente alla TC per la classificazione",
    "bosniak_change4": "Definisce chiaramente che il nodulo murale/settale (componente solido con enhancement) = Bosniak IV",
    "bosniak_change5": "La regola del 'grado massimo' persiste: la caratteristica individuale più sospetta determina la categoria finale",
    "bosniak_indicationsTitle": "Indicazioni",
    "bosniak_indication1": "Masse renali cistiche incidentali rilevate in TC o RM con contrasto",
    "bosniak_indication2": "Follow-up di cisti precedentemente classificate come Bosniak IIF",
    "bosniak_indication3": "Valutazione preoperatoria di masse renali cistiche complesse per pianificazione chirurgica",
    "bosniak_limitationsTitle": "Limitazioni",
    "bosniak_limitation1": "Non applicare a masse renali con > 25% di componente solido (usare classificazione delle masse solide)",
    "bosniak_limitation2": "Non valida senza contrasto endovenoso — l'enhancement è pilastro fondamentale della classificazione",
    "bosniak_limitation3": "Escludere masse di etiologia infettiva/infiammatoria nota (ascessi, cisti infette)",
    "bosniak_limitation4": "Non progettata per masse cistiche di origine vascolare (aneurismi, MAV renali)",
    "bosniak_followUpTitle": "Follow-up raccomandato",
    "bosniak_followUp12": "Non richiede follow-up con imaging",
    "bosniak_followUpIIF": "TC o RM a 6 e 12 mesi, poi annuale per 5 anni. Se progredisce → riclassificare.",
    "bosniak_followUpIII": "Chirurgia parziale/radicale o sorveglianza attiva con imaging ogni 6 mesi secondo comorbilità e preferenza del paziente.",
    "bosniak_followUpIV": "Trattamento chirurgico (nefrectomia parziale preferita se tecnicamente fattibile). Biopsia se necessaria conferma preoperatoria.",
    "bosniak_referencesTitle": "Riferimenti",
    "garden_classification": "Classificazione Garden",
    "garden_desc": "Fratture sottocapitali del collo femorale — Garden",
    "garden_criteria": "Classificazione di Garden",
    "garden_description": "Sistema di classificazione per fratture sottocapitali del collo femorale basato sul grado di spostamento dei frammenti ossei nella radiografia AP.",
    "garden_fracturePattern": "Pattern di frattura",
    "garden_trabecularPattern": "Pattern trabecolare",
    "garden_chooseOne": "Scegliere 1",
    "garden_highestGrade": "Il grado più alto determina la classificazione",
    "garden_selectFeatures": "Seleziona caratteristiche",
    "garden_displacement": "Spostamento",
    "garden_fractureIncomplete": "Frattura incompleta (impattazione in valgo, solo corticale inferiore)",
    "garden_fractureCompleteNondisplaced": "Frattura completa, non spostata (entrambe le corticali interrotte, allineate)",
    "garden_fractureCompletePartial": "Frattura completa, parzialmente spostata",
    "garden_fractureCompleteFull": "Frattura completa, totalmente spostata (nessun contatto tra i frammenti)",
    "garden_trabecularAngulated": "Trabecole angolate (pattern di impattazione in valgo)",
    "garden_trabecularInterrupted": "Trabecole interrotte, allineate attraverso la linea di frattura",
    "garden_trabecularDisrupted": "Trabecole disrutte con rotazione della testa femorale",
    "garden_trabecularNone": "Nessuna continuità trabecolare (separazione completa)",
    "garden_gI_label": "Incompleta / Impattata in valgo",
    "garden_gII_label": "Completa, non spostata",
    "garden_gIII_label": "Completa, parzialmente spostata",
    "garden_gIV_label": "Completa, totalmente spostata",
    "garden_scoringNote": "Il grado Garden finale è determinato dal livello di spostamento osservato. Nella pratica clinica, i gradi I-II (non spostate) e III-IV (spostate) sono raggruppati per le decisioni terapeutiche.",
    "garden_reference": "Riferimento:",
    "garden_conclusionI": "Frattura sottocapitale del collo femorale classificata come Garden I (frattura incompleta / impattata in valgo). Si raccomanda fissazione interna con viti cannulate.",
    "garden_conclusionII": "Frattura sottocapitale del collo femorale classificata come Garden II (frattura completa, non spostata). Si raccomanda fissazione interna con viti cannulate.",
    "garden_conclusionIII": "Frattura sottocapitale del collo femorale classificata come Garden III (frattura completa, parzialmente spostata). Si raccomanda artroplastica parziale o totale secondo l'età e il livello di attività del paziente.",
    "garden_conclusionIV": "Frattura sottocapitale del collo femorale classificata come Garden IV (frattura completa, totalmente spostata). Si raccomanda artroplastica parziale o totale secondo l'età e il livello di attività del paziente.",
    "garden_clickToInsert": "Fare clic per inserire la raccomandazione nel referto",
    "garden_toggleHighlight": "Mostra/nascondi evidenziazione",
    "eaton_classification": "Classificazione Eaton-Littler",
    "eaton_desc": "Artrosi trapeziometacarpale (rizoartrosi) — Eaton-Littler",
    "eaton_criteria": "Classificazione di Eaton-Littler",
    "eaton_description": "Sistema di classificazione radiologica per l'artrosi trapeziometacarpale (rizoartrosi) basato sul restringimento articolare, osteofiti, sublussazione e coinvolgimento dell'articolazione scafotrapezioidale (STT).",
    "eaton_jointSpace": "Spazio articolare",
    "eaton_osteophytes": "Osteofiti",
    "eaton_subluxation": "Sublussazione",
    "eaton_sttJoint": "Articolazione STT",
    "eaton_chooseOne": "Scegliere 1",
    "eaton_highestStage": "Lo stadio più alto determina la classificazione",
    "eaton_selectFeatures": "Seleziona caratteristiche",
    "eaton_jointNormal": "Spazio articolare normale o leggermente allargato",
    "eaton_jointSlightNarrowing": "Lieve restringimento dello spazio articolare",
    "eaton_jointMarkedNarrowing": "Marcato restringimento o distruzione articolare",
    "eaton_jointNarrowingBoth": "Restringimento marcato di TMC + articolazione STT",
    "eaton_osteoAbsent": "Nessun osteofita",
    "eaton_osteoSmall": "Osteofiti piccoli (< 2 mm)",
    "eaton_osteoLarge": "Osteofiti > 2 mm, sclerosi subcondrale/cisti",
    "eaton_osteoBothJoints": "Osteofiti nelle articolazioni TMC + STT",
    "eaton_subluxMinimal": "Sublussazione ≤ 1/3 della superficie articolare",
    "eaton_subluxSlight": "Lieve sublussazione dell'articolazione TMC",
    "eaton_subluxSignificant": "Sublussazione significativa (> 1/3)",
    "eaton_subluxFixed": "Sublussazione TMC + deformità fissa in adduzione",
    "eaton_sttNormalI": "Articolazione STT normale",
    "eaton_sttNormalII": "Articolazione STT normale",
    "eaton_sttNormalIII": "Articolazione STT normale",
    "eaton_sttAffected": "Articolazione STT coinvolta (restringimento, osteofiti, sclerosi)",
    "eaton_eI_label": "Pre-artrosico",
    "eaton_eII_label": "Artrosi lieve",
    "eaton_eIII_label": "Artrosi avanzata (solo TMC)",
    "eaton_eIV_label": "Artrosi pantrapezioidale (TMC + STT)",
    "eaton_scoringNote": "Lo stadio finale di Eaton-Littler è determinato dal reperto radiologico di maggiore gravità. Gli stadi I-II sono generalmente trattati in modo conservativo, mentre gli stadi III-IV richiedono valutazione chirurgica.",
    "eaton_reference": "Riferimento:",
    "eaton_conclusionI": "Artrosi trapeziometacarpale classificata come Eaton-Littler I (stadio pre-artrosico). Si raccomanda trattamento conservativo con tutore, antinfiammatori e riabilitazione.",
    "eaton_conclusionII": "Artrosi trapeziometacarpale classificata come Eaton-Littler II (artrosi lieve). Si raccomanda trattamento conservativo o chirurgia secondo la sintomatologia clinica.",
    "eaton_conclusionIII": "Artrosi trapeziometacarpale classificata come Eaton-Littler III (artrosi avanzata dell'articolazione TMC). Si raccomanda trapeziectomia o artroplastica.",
    "eaton_conclusionIV": "Artrosi trapeziometacarpale classificata come Eaton-Littler IV (artrosi pantrapezioidale, coinvolgimento TMC + STT). Si raccomanda artrodesi o artroplastica totale.",
    "snyder_classification": "Classificazione di Snyder",
    "snyder_desc": "Rotture complete della cuffia dei rotatori — Snyder",
    "snyder_criteria": "Classificazione di Snyder",
    "snyder_description": "Sistema di classificazione per le rotture complete della cuffia dei rotatori (sovraspinato e/o infraspinato) basato sul diametro anteroposteriore della rottura e sul numero di tendini coinvolti.",
    "snyder_tearSize": "Dimensione della rottura (AP)",
    "snyder_tendonCount": "Tendini coinvolti",
    "snyder_chooseOne": "Scegliere 1",
    "snyder_highestGrade": "Il grado più alto determina la classificazione",
    "snyder_selectFeatures": "Selezionare le caratteristiche",
    "snyder_tearSmall": "Rottura completa < 10 mm di diametro AP",
    "snyder_tearMedium": "Rottura completa 10–20 mm di diametro AP",
    "snyder_tearLarge": "Rottura completa > 20 mm di diametro AP",
    "snyder_tearMassive": "Rottura completa che coinvolge ≥ 2 tendini",
    "snyder_tendonSingle": "Singolo tendine (sovraspinato o infraspinato)",
    "snyder_tendonSingleRetracted": "Singolo tendine con retrazione moderata",
    "snyder_tendonSingleAtrophy": "Singolo tendine con retrazione/atrofia significativa",
    "snyder_tendonMultiple": "Due o più tendini coinvolti",
    "snyder_sC1_label": "Rottura completa piccola (< 10 mm)",
    "snyder_sC2_label": "Rottura completa media (10–20 mm)",
    "snyder_sC3_label": "Rottura completa grande (> 20 mm)",
    "snyder_sC4_label": "Rottura massiva (≥ 2 tendini)",
    "snyder_scoringNote": "Il grado Snyder finale è determinato dal reperto di maggiore gravità. C4 ha priorità quando sono coinvolti due o più tendini, indipendentemente dalla dimensione della rottura.",
    "snyder_reference": "Riferimento:",
    "snyder_conclusionC1": "Rottura completa della cuffia dei rotatori classificata come Snyder C1 (rottura piccola, < 10 mm di diametro AP). Si raccomanda riparazione artroscopica.",
    "snyder_conclusionC2": "Rottura completa della cuffia dei rotatori classificata come Snyder C2 (rottura media, 10–20 mm di diametro AP). Si raccomanda riparazione artroscopica o mini-open.",
    "snyder_conclusionC3": "Rottura completa della cuffia dei rotatori classificata come Snyder C3 (rottura grande, > 20 mm di diametro AP). Si raccomanda riparazione aperta o artroscopica secondo retrazione e qualità tissutale.",
    "snyder_conclusionC4": "Rottura completa della cuffia dei rotatori classificata come Snyder C4 (rottura massiva che coinvolge due o più tendini). Considerare trasferimento tendineo o artroplastica inversa della spalla.",
    "herbert_classification": "Classificazione di Herbert-Fisher",
    "herbert_desc": "Fratture dello scafoide carpale — Herbert-Fisher",
    "herbert_criteria": "Scafoide carpale · Herbert e Fisher, 1984",
    "herbert_description": "Classifica le fratture dello scafoide carpale in base a stabilità ed evoluzione (Herbert e Fisher, 1984) e orienta la gestione.",
    "herbert_acutePattern": "Frattura acuta",
    "herbert_instability": "Criterio di instabilità",
    "herbert_chronicity": "Evoluzione",
    "herbert_chooseOne": "Scegli 1",
    "herbert_optional": "Opzionale",
    "herbert_highestGrade": "Il tipo più grave determina la classificazione",
    "herbert_selectFeatures": "Seleziona le caratteristiche",
    "herbert_a1Tubercle": "Frattura del tubercolo",
    "herbert_a2WaistNondisplaced": "Vita non scomposta (confermata da TC)",
    "herbert_b1DistalOblique": "Obliqua del terzo distale",
    "herbert_b2WaistDisplaced": "Vita scomposta o mobile",
    "herbert_b3ProximalPole": "Polo prossimale",
    "herbert_b4Perilunate": "Frattura-lussazione transscafo-perilunare",
    "herbert_b5Comminuted": "Comminuta",
    "herbert_instDisplacement": "Scomposizione > 1 mm",
    "herbert_instDisi": "DISI: angolo scafo-semilunare > 60°",
    "herbert_instAngle": "Angolo intrascafoideo laterale > 35°",
    "herbert_instComminution": "Comminuzione",
    "herbert_instPerilunate": "Parte di una lesione perilunare",
    "herbert_cDelayed": "Ritardo di consolidazione",
    "herbert_d1Fibrous": "Pseudoartrosi fibrosa (polo prossimale di solito vitale)",
    "herbert_d2Mobile": "Pseudoartrosi mobile",
    "herbert_d3Sclerotic": "Pseudoartrosi sclerotica, con difetto e deformità a gobba",
    "herbert_d4Avn": "Necrosi avascolare con collasso e perdita dell'architettura",
    "herbert_extB3a": "Angolo scafo-semilunare < 60°",
    "herbert_extB3b": "Angolo scafo-semilunare > 60°",
    "herbert_extShortLt2": "Accorciamento < 2 mm",
    "herbert_extShortGt2": "Accorciamento > 2 mm",
    "herbert_extSlac": "Con alterazioni SLAC",
    "herbert_tA_label": "Acuta stabile",
    "herbert_tB_label": "Acuta instabile",
    "herbert_tC_label": "Ritardo di consolidazione",
    "herbert_tD_label": "Pseudoartrosi stabilizzata",
    "herbert_recA": "Trattamento conservativo o fissazione percutanea.",
    "herbert_recB": "Fissazione chirurgica.",
    "herbert_recC": "Chirurgia, spesso con innesto osseo.",
    "herbert_recD": "Chirurgia, spesso con innesto osseo.",
    "herbert_scoringNote": "Il tipo finale è determinato dal reperto più grave. Uno qualsiasi di questi criteri rende la frattura acuta instabile (B): scomposizione > 1 mm, angolo scafo-semilunare > 60° (DISI), angolo intrascafoideo laterale > 35°, comminuzione o lesione perilunare. Il polo prossimale (B3) è sempre instabile per la vascolarizzazione retrograda. Confermare A2 rispetto a B2 con TC.",
    "herbert_reference": "Riferimento:",
    "herbert_conclusion": "Frattura dello scafoide carpale classificata come Herbert {{subtype}} ({{label}}). {{recommendation}}",
    "tnm_lung_classification": "Classificazione TNM Polmone",
    "tnmLungName": "TNM Polmone",
    "tnm_lung_desc": "Carcinoma polmonare non a piccole cellule — TNM 7ª edizione",
    "tnm_lung_criteria": "Classificazione TNM Polmone",
    "tnm_lung_description": "Sistema di stadiazione per il carcinoma polmonare non a piccole cellule basato sui descrittori del tumore primario (T), dei linfonodi regionali (N) e delle metastasi a distanza (M), secondo la 7ª edizione TNM (IASLC/UICC/AJCC, 2010).",
    "tnm_lung_tumorDescriptor": "Tumore primario (T)",
    "tnm_lung_nodeDescriptor": "Linfonodi regionali (N)",
    "tnm_lung_metastasisDescriptor": "Metastasi a distanza (M)",
    "tnm_lung_chooseOne": "Scegliere 1",
    "tnm_lung_stageGrouping": "Determinazione dello stadio",
    "tnm_lung_stage": "Stadio",
    "tnm_lung_selectDescriptors": "Selezionare i descrittori T, N e M",
    "tnm_lung_survival5y": "Sopravvivenza 5 anni",
    "tnm_lung_scoringNote": "Lo stadio TNM finale è determinato combinando i descrittori T, N e M. In presenza di M1, lo stadio è sempre IV indipendentemente da T e N.",
    "tnm_lung_reference": "Riferimento:",
    "tnm_lung_tTX": "TX — Il tumore primario non può essere valutato",
    "tnm_lung_tT0": "T0 — Nessuna evidenza di tumore primario",
    "tnm_lung_tTis": "Tis — Carcinoma in situ",
    "tnm_lung_tT1a": "T1a — Tumore ≤ 2 cm",
    "tnm_lung_tT1b": "T1b — Tumore > 2 cm e ≤ 3 cm",
    "tnm_lung_tT2a": "T2a — Tumore > 3 cm e ≤ 5 cm",
    "tnm_lung_tT2b": "T2b — Tumore > 5 cm e ≤ 7 cm",
    "tnm_lung_tT3": "T3 — Tumore > 7 cm, o invasione di parete toracica / diaframma / nervo frenico, o nodulo/i nello stesso lobo",
    "tnm_lung_tT4": "T4 — Invasione di mediastino, cuore, grandi vasi, trachea, carena, esofago, corpo vertebrale; o nodulo/i in lobo ipsilaterale diverso",
    "tnm_lung_nNX": "NX — I linfonodi regionali non possono essere valutati",
    "tnm_lung_nN0": "N0 — Nessuna metastasi nei linfonodi regionali",
    "tnm_lung_nN1": "N1 — Metastasi nei linfonodi peribronchiali / ilari ipsilaterali",
    "tnm_lung_nN2": "N2 — Metastasi nei linfonodi mediastinici / subcarinali ipsilaterali",
    "tnm_lung_nN3": "N3 — Metastasi nei linfonodi mediastinici / ilari controlaterali, scaleni o sopraclaveari",
    "tnm_lung_mM0": "M0 — Nessuna metastasi a distanza",
    "tnm_lung_mM1a": "M1a — Nodulo/i nel polmone controlaterale, versamento pleurico / pericardico maligno",
    "tnm_lung_mM1b": "M1b — Metastasi a distanza (extratoracica)",
    "tnm_lung_conclusionOculto": "Carcinoma polmonare in stadio Occulto (TX N0 M0). Si raccomanda di completare gli accertamenti diagnostici.",
    "tnm_lung_conclusion0": "Carcinoma polmonare in stadio 0 (Tis N0 M0, carcinoma in situ). Si raccomanda resezione chirurgica.",
    "tnm_lung_conclusionIA": "Carcinoma polmonare in stadio IA (T1a-T1b N0 M0). Si raccomanda resezione chirurgica (lobectomia). Sopravvivenza a 5 anni: 73%.",
    "tnm_lung_conclusionIB": "Carcinoma polmonare in stadio IB (T2a N0 M0). Si raccomanda resezione chirurgica ± chemioterapia adiuvante. Sopravvivenza a 5 anni: 58%.",
    "tnm_lung_conclusionIIA": "Carcinoma polmonare in stadio IIA (T1-T2a N1, T2b N0). Si raccomanda resezione chirurgica più chemioterapia adiuvante. Sopravvivenza a 5 anni: 46%.",
    "tnm_lung_conclusionIIB": "Carcinoma polmonare in stadio IIB (T2b N1, T3 N0). Si raccomanda resezione chirurgica più chemioterapia adiuvante. Sopravvivenza a 5 anni: 36%.",
    "tnm_lung_conclusionIIIA": "Carcinoma polmonare in stadio IIIA (T1-T2 N2, T3 N1-N2, T4 N0-N1). Si raccomanda chemioradioterapia con valutazione chirurgica. Sopravvivenza a 5 anni: 24%.",
    "tnm_lung_conclusionIIIB": "Carcinoma polmonare in stadio IIIB (T4 N2, qualsiasi T N3). Si raccomanda chemioradioterapia. Sopravvivenza a 5 anni: 9%.",
    "tnm_lung_conclusionIV": "Carcinoma polmonare in stadio IV (qualsiasi T, qualsiasi N, M1). Si raccomanda terapia sistemica (chemioterapia / terapia mirata / immunoterapia). Sopravvivenza a 5 anni: 13%.",
    "smartBarPlaceholder": "Scrivi qui...",
    "noCommandsUnderstood": "Non ho capito bene cosa vuoi che faccia. Potresti essere più specifico, per favore?",
    "bold": "Grassetto",
    "italic": "Corsivo",
    "underline": "Sottolineato",
    "textColor": "Colore del testo",
    "custom": "Personalizzato",
    "untitled": "Referto senza titolo",
    "facturationRate": "Fatturazione settimanale",
    "billedReports": "referti fatturati",
    "vsLastWeek": "vs settimana scorsa",
    "weeklyCompletionRate": "Report settimanali",
    "avgEditTime": "Tempo medio per referto",
    "avgEditTimeSub": "{{count}} referti questa settimana",
    "avgEditTimeEmpty": "Nessun dato disponibile",
    "byPeriod": {
      "month":  { "facturationRate": "Fatturazione del mese",         "avgEditTimeSub": "{{count}} referti questo mese" },
      "week":   { "facturationRate": "Fatturazione settimanale",      "avgEditTimeSub": "{{count}} referti questa settimana" },
      "day":    { "facturationRate": "Fatturazione di oggi",          "avgEditTimeSub": "{{count}} referti oggi" },
      "last30": { "facturationRate": "Fatturazione ultimi 30 giorni", "avgEditTimeSub": "{{count}} referti negli ultimi 30 giorni" }
    },
    "moreStats": "Vedi tutte le statistiche",
    "moreStatsDesc": "Analizza la tua produttività e le tendenze",
    "versionHistory": "Cronologia versioni",
    "closePanel": "Chiudi pannello",
    "saveDocToSeeHistory": "Salva il documento per visualizzare la cronologia.",
    "noVersionsSaved": "Nessuna versione salvata.",
    "restoring": "Ripristino in corso…",
    "restoreThisVersion": "Ripristina questa versione",
    "loadMore": "Carica altro",
    "comparingDiffs": "Confronto delle differenze",
    "exitPreview": "Esci dall'anteprima",
    "versionRestored": "Versione ripristinata",
    "versionRestoreError": "Impossibile ripristinare la versione",
    "triggerAutosave": "Salvataggio automatico",
    "triggerManualSave": "Salvataggio manuale",
    "triggerAiGeneration": "Generazione IA",
    "triggerVoiceCommand": "Comando vocale",
    "triggerMagicWrite": "Scrittura magica",
    "triggerTemplateInserted": "Modello inserito",
    "triggerTemplateChange": "Cambio modello",
    "sourceMagicWriting": "Scrittura magica",
    "sourceManual": "Manuale",
    "sourceDictation": "Dettatura",
    "triggerVersionRestored": "Versione ripristinata",
    "standardTemplateHint": "Non hai indicato nessun modello, quindi ho usato il modello standard.\n Se vuoi, dimmi quale modello usare e lo applicherò subito.\n Per esempio: «Usa il modello di TC del torace. Nel parenchima polmonare si identifica...».",
    "patientData": "Dati del paziente",
    "patientHistory": "Storico del paziente",
    "closePatientPanel": "Chiudi pannello paziente",
    "demographics": "Dati demografici",
    "birth": "Nascita",
    "age": "Età",
    "sex": "Sesso",
    "studySection": "Studio",
    "date": "Data",
    "descriptionLabel": "Descrizione",
    "clinic": "Clinica",
    "reportHistory": "Storico dei referti",
    "signed": "Firmato",
    "reportIssueTitle": "Segnala un problema",
    "reportIssueThanks": "Grazie per la tua segnalazione!",
    "reportIssueReview": "Lo esamineremo il prima possibile e lavoreremo per risolverlo.",
    "reportIssueDescribe": "Descrivi il problema",
    "reportIssuePlaceholder": "Descrivi in dettaglio cosa è successo, su quale schermata o azione e come riprodurlo...",
    "reportIssueSendError": "Impossibile inviare il problema. Riprova.",
    "reportIssueConsent": "Accetto che il team Ainovis mi contatti per ulteriori dettagli",
    "reportIssueDisclaimer": "Utilizzeremo queste informazioni esclusivamente per migliorare il nostro strumento e risolvere il problema segnalato.",
    "reportIssueSubmit": "Invia segnalazione",
    "menuFile": "File",
    "menuInsert": "Inserisci",
    "menuClassifications": "Classificazioni",
    "menuTemplates": "Modelli",
    "menuSupport": "Supporto",
    "menuCopy": "Copia",
    "menuShare": "Condividi",
    "menuVersionHistory": "Cronologia versioni",
    "menuDownloadPdf": "Scarica come PDF",
    "menuPrint": "Stampa",
    "menuRename": "Rinomina",
    "menuDelete": "Elimina",
    "menuLanguage": "Lingua",
    "menuImage": "Immagine",
    "menuTable": "Tabella",
    "insertTable": "Inserisci tabella",
    "menuDivider": "Linea divisoria",
    "menuChart": "Grafico",
    "menuShortcuts": "Scorciatoie da tastiera",
    "menuAskCarolina": "Chiedi a Carolina",
    "menuReportIssue": "Segnala un problema",
    "menuExploreTemplates": "Esplora modelli",
    "menuUseAinovisTemplates": "Usa i modelli di Ainovis",
    "menuCreateTemplate": "Crea modello",
    "saveAsTemplate": "Salva come modello",
    "templateNameInvalid": "Il nome può contenere solo lettere, numeri, spazi, trattini, apostrofi e punti",
    "templateNameAinovis": "Esiste già un modello Ainovis con quel nome. Scegli un nome diverso.",
    "templateNameGroup": "Il nome del modello non può contenere il nome del tuo gruppo.",
    "templateName": "Nome del modello",
    "contentCopiedToClipboard": "Contenuto copiato negli appunti",
    "errorCopyingContent": "Impossibile copiare il contenuto",
    "noSavedDocToDelete": "Nessun documento salvato da eliminare.",
    "deleteDocumentTitle": "Elimina documento",
    "confirmDeleteDocument": "Sei sicuro di voler eliminare questo documento? Questa azione non può essere annullata.",
    "documentDeleted": "Documento eliminato con successo.",
    "errorDeletingDocument": "Impossibile eliminare il documento.",
    "errorDeleteForbidden": "Non hai il permesso di eliminare questa bozza.",
    "draftNoAccessTitle": "Non hai accesso a questa bozza",
    "draftNoAccessMessage": "Chiedi al suo autore di condividerla con te.",
    "draftNotFoundTitle": "Questa bozza non esiste",
    "draftNotFoundMessage": "Il suo autore potrebbe averla eliminata.",
    "noContentToExport": "Nessun contenuto da esportare.",
    "browserBlockedPopup": "Il browser ha bloccato il popup.",
    "saveTemplate": "Salva modello",
    "backToReports": "Torna ai referti",
    "untitledTemplate": "Modello senza titolo",
    "templateTitleRequired": "Devi aggiungere un titolo al modello",
    "actionVersions": "Versioni",
    "actionPatients": "Pazienti",
    "actionReportsHistory": "Referti precedenti",
    "patientsSidebarTitlePatient": "Dati del paziente",
    "patientsSidebarTitleHistory": "Storico del paziente",
    "patientsSidebarClose": "Chiudi pannello paziente",
    "patientsSidebarNotConnected": "Non connesso",
    "patientsSidebarTabPatient": "Dati del paziente",
    "patientsSidebarTabHistory": "Storico dei referti",
    "patientsSidebarSectionDemographics": "Demografia",
    "patientsSidebarSectionStudy": "Studio attuale",
    "patientsSidebarSectionClinical": "Clinica",
    "patientsSidebarLabelBirth": "Nascita",
    "patientsSidebarLabelAge": "Età",
    "patientsSidebarLabelSex": "Sesso",
    "patientsSidebarLabelModality": "Modalità",
    "patientsSidebarLabelDate": "Data",
    "patientsSidebarLabelAccession": "N. Accesso",
    "patientsSidebarLabelDescription": "Descrizione",
    "patientsSidebarLabelReferring": "Medico richiedente",
    "patientsSidebarLabelReason": "Motivo della richiesta",
    "patientsSidebarAddReason": "Aggiungi motivo della richiesta",
    "patientsSidebarAddReasonShort": "Aggiungi",
    "patientsSidebarReasonHint": "Devi essere connesso a un sistema esterno (RIS/PACS) per abilitare questa funzionalità.",
    "patientsSidebarStudyUid": "Study UID",
    "patientsSidebarSexMale": "Maschio",
    "patientsSidebarSexFemale": "Femmina",
    "patientsSidebarYearsOld": "{{years}} anni",
    "patientsSidebarNoPatientName": "Paziente senza nome",
    "patientsSidebarReportFallbackTitle": "Referto",
    "patientsSidebarNoReport": "Nessun referto",
    "patientsSidebarHistoryEmpty": "Nessun referto precedente disponibile",
    "patientsSidebarHistoryUnread": "Non è stato possibile caricare i referti",
    "patientsSidebarHistoryCount": "{{studies}} studi · {{reports}} referti",
    "patientSummaryButton": "Riassumi",
    "patientSummaryButtonHint": "Riepilogo dei referti precedenti generato da Carolina",
    "patientSummaryTitle": "Riepilogo del paziente",
    "patientSummaryRegenerate": "Rigenera",
    "patientSummaryCollapse": "Comprimi riepilogo",
    "patientSummaryExpand": "Espandi riepilogo",
    "patientSummaryShowMore": "Mostra tutto",
    "patientSummaryShowLess": "Mostra meno",
    "patientSummaryStepAnalyzing": "Analisi dei referti precedenti ({{count}})…",
    "patientSummaryStepWriting": "Stesura del riepilogo…",
    "patientSummaryNoPriors": "Non ci sono referti precedenti con testo analizzabile.",
    "patientSummaryNoFindings": "Non sono stati trovati antecedenti rilevanti nei referti precedenti.",
    "patientSummaryStale": "I referti precedenti sono cambiati da quando è stato generato questo riepilogo.",
    "patientSummaryRetry": "Riprova",
    "patientSummaryErrorGeneric": "Impossibile generare il riepilogo.",
    "patientSummaryErrorTimeout": "Il riepilogo ha richiesto troppo tempo. Riprova.",
    "patientSummaryErrorLimits": "Ci sono troppi referti precedenti da riassumere in una volta.",
    "patientSummaryErrorUnavailable": "Il servizio di riepilogo non è disponibile al momento.",
    "patientSummaryDisclaimer": "Generato da Carolina alle {{time}} · Verifica i riferimenti",
    "patientSummaryReferences": "Riferimenti ({{count}})",
    "patientSummaryViewInReport": "Vedi nel referto",
    "actionAiAssistant": "Assistente IA",
    "actionMicQr": "Microfono del telefono",
    "micQrSidebarTitle": "Microfono del telefono",
    "micQrSidebarClose": "Chiudi pannello microfono",
    "micQrStep1": "Apri la fotocamera del telefono.",
    "micQrStep2": "Scansiona il codice QR.",
    "micQrStep3": "Consenti l'accesso al microfono.",
    "micQrStep4": "Tocca il pulsante di registrazione.",
    "micQrNeedsPermission": "Consenti l'accesso al microfono sul telefono prima di registrare.",
    "micQrLoading": "Generazione del codice…",
    "micQrError": "Impossibile creare il codice. Riprova.",
    "micQrExpired": "Il codice è scaduto",
    "micQrExpiresIn": "Scade tra {{minutes}} min",
    "micQrHttpsHint": "Il telefono richiede HTTPS (o localhost) per usare il microfono.",
    "micQrRefresh": "Genera un altro codice",
    "micQrWaiting": "In attesa del telefono…",
    "micQrStartRemote": "Connesso al microfono del telefono. Tocca per registrare.",
    "micQrConnected": "Telefono connesso",
    "micQrConnectedHint": "Tocca il pulsante di registrazione.",
    "micQrDisconnect": "Disconnetti",
    "useTemplate": "Usa modello",
    "newChat": "Nuova chat",
    "closeAiPanel": "Chiudi pannello IA",
    "aiHeroText": "Chiedimi qualsiasi dubbio tu abbia su Ainovis",
    "aiPlaceholder": "Scrivi un messaggio...",
    "aiErrorMessage": "Mi dispiace, non sono riuscito a elaborare la tua domanda. Riprova.",
    "aiQuestion1": "Come genero un referto con la SmartBar?",
    "aiQuestion2": "Come avvio la dettatura vocale?",
    "aiQuestion3": "Quali classificazioni mediche posso usare?",
    "toolbarParagraphStyle": "Stile paragrafo",
    "toolbarFontFamily": "Carattere",
    "toolbarStyleNormal": "Testo normale",
    "toolbarStyleH1": "Intestazione 1",
    "toolbarStyleH2": "Intestazione 2",
    "toolbarStyleH3": "Intestazione 3",
    "toolbarStyleH4": "Intestazione 4",
    "toolbarStyleH5": "Intestazione 5",
    "toolbarApplyStyleToAll": "Applica a tutti: \"{{style}}\"",
    "toolbarBold": "Grassetto (Ctrl+B)",
    "toolbarItalic": "Corsivo (Ctrl+I)",
    "toolbarUnderline": "Sottolineato (Ctrl+U)",
    "toolbarStrikethrough": "Barrato",
    "toolbarTextColor": "Colore testo",
    "toolbarHighlightColor": "Colore evidenziazione",
    "toolbarNoColor": "Nessuno",
    "toolbarPresetColors": "Colori predefiniti",
    "toolbarCustomColors": "Colori personalizzati",
    "toolbarAddCustomColor": "Colore personalizzato...",
    "toolbarAlignLeft": "Allinea a sinistra",
    "toolbarAlignCenter": "Centra",
    "toolbarAlignRight": "Allinea a destra",
    "toolbarJustify": "Giustifica",
    "toolbarBulletList": "Elenco puntato",
    "toolbarNumberedList": "Elenco numerato",
    "toolbarLineSpacing": "Interlinea",
    "toolbarRemoveSpaceBefore": "Rimuovi spazio prima del paragrafo",
    "toolbarAddSpaceBefore": "Aggiungi spazio prima del paragrafo",
    "toolbarRestoreSpaceAfter": "Ripristina spazio dopo il paragrafo",
    "toolbarRemoveSpaceAfter": "Rimuovi spazio dopo il paragrafo",
    "toolbarCustomSpacing": "Spaziatura personalizzata…",
    "toolbarKeepWithNext": "Mantieni con il successivo",
    "toolbarKeepLinesTogether": "Mantieni le righe insieme",
    "toolbarAvoidOrphans": "Evita righe isolate",
    "toolbarPageBreakBefore": "Aggiungi interruzione di pagina prima",
    "toolbarDecreaseSize": "Riduci dimensione",
    "toolbarIncreaseSize": "Aumenta dimensione",
    "toolbarAlignment": "Allineamento",
    "toolbarSingleSpacing": "Singolo",
    "toolbarDoubleSpacing": "Doppio",
    "toolbarZoom": "Zoom",
    "toolbarZoomOut": "Riduci zoom",
    "toolbarZoomIn": "Aumenta zoom",
    "toolbarUndo": "Annulla (Ctrl+Z)",
    "toolbarRedo": "Ripeti (Ctrl+Y)",
    "toolbarMoreOptions": "Altre opzioni di formattazione",
    "toolbarFindingsMode": "Modalità riscontri",
    "toolbarFindingsFirst": "Riscontri all'inizio",
    "toolbarFindingsFirstDesc": "I riscontri sono posizionati sopra quelli normali",
    "toolbarFindingsInside": "Riscontri nel testo",
    "toolbarFindingsInsideDesc": "I riscontri sono integrati nel corpo del referto",
    "toolbarHighlightFindings": "Evidenziare i riscontri",
    "toolbarLineSpacingSingle": "Singola",
    "toolbarLineSpacingDouble": "Doppia",
    "toolbarLanguagePlaceholder": "Lingua"
  },
  "inconsistencies": {
    "label": "Incongruenza",
    "show": "Mostra",
    "hide": "Ignora",
    "mixedLateralityTerm": "Lateralità miste",
    "mixedLateralityReason": "Sono state rilevate lateralità diverse (DESTRA e SINISTRA) nello stesso studio. Si prega di verificare se è corretto.",
    "missingLateralityTerm": "Lateralità mancante",
    "missingLateralityReason": "La procedura richiede lateralità ma nessuna (destra o sinistra) è stata rilevata nella tecnica."
  },
  "settings": {
    "title": "Impostazioni",
    "subtitle": "Personalizza la lingua e il formato dei referti",
    "profile": "Profilo",
    "account": "Account",
    "preferences": "Preferenze",
    "language": "Lingua",
    "languageDescription": "Seleziona la lingua dell'interfaccia utente",
    "theme": "Tema",
    "themeDescription": "Scegli il tema colore dell'applicazione",
    "themeOptions": {
      "light": "Chiaro",
      "dark": "Scuro",
      "system": "Sistema"
    },
    "notifications": "Notifiche",
    "security": "Sicurezza",
    "changePassword": "Cambia password",
    "currentPassword": "Password attuale",
    "privacyPolicy": "Informativa sulla privacy",
    "termsOfService": "Termini di servizio",
    "audio": "Audio",
    "audioDescription": "Configura il dispositivo di ingresso audio per la dettatura",
    "audioDevice": "Dispositivo audio",
    "audioDeviceDescription": "Seleziona il microfono che vuoi usare per la dettatura",
    "selectMicrophone": "Seleziona microfono",
    "selectedDevice": "Dispositivo selezionato",
    "microphone": "Microfono",
    "session": "Sessione",
    "sessionDescription": "Gestisci la tua sessione corrente",
    "onboarding": "Tutorial",
    "onboardingDescription": "Rivedi il tutorial dell'applicazione",
    "onboardingText": "Se vuoi rivedere il tutorial guidato, clicca il pulsante per riattivarlo. Verrà mostrato la prossima volta che accedi alle schermate corrispondenti.",
    "onboardingButton": "Riattiva tutorial",
    "onboardingResetSuccess": "Tutorial riattivato con successo",
    "logoutText": "Quando esci, verrai reindirizzato alla pagina di accesso",
    "signature": "Firma",
    "signatureDescription": "Scrivi il testo che verrà inserito quando firmi un referto",
    "defaultSignatureName": "Dott. Nome Cognome",
    "signedBy": "Firmato da",
    "colegiadoLabel": "N. iscrizione",
    "signatureHint": "Configura il tuo numero di iscrizione e il titolo professionale nella sezione di amministrazione utenti.",
    "signatureSaved": "Firma salvata",
    "deleteSignature": "Elimina firma",
    "generateSignature": "Genera firma",
    "ainovisTemplates": "Modelli di Ainovis",
    "ainovisTemplatesDescription": "Usa i modelli predefiniti di Ainovis durante la generazione dei referti",
    "ainovisTemplatesText": "Attiva questa opzione per usare i modelli di Ainovis. Se la disattivi, verranno usati solo i tuoi modelli personali."
  },
  "users": {
    "professionalTitle": "Titolo",
    "professionalTitlePlaceholder": "Dott., Dott.ssa, ecc.",
    "practitionerIdentifier": "N. iscrizione",
    "practitionerIdentifierPlaceholder": "Es: 282812345",
    "practitionerIdentifierSystem": "Sistema di identificazione",
    "practitionerIdentifierSystemPlaceholder": "URI dell'ordine o del registro professionale",
    "title": "Utenti",
    "user": "utente",
    "usersPlural": "utenti",
    "userList": "Elenco utenti",
    "addUser": "Aggiungi utente",
    "editUser": "Modifica utente",
    "deleteUser": "Elimina utente",
    "userDetails": "Dettagli utente",
    "newUser": "Nuovo Utente",
    "management": "Gestione Utenti",
    "subtitle": "Gestisci e visualizza le informazioni degli utenti del sistema",
    "searchPlaceholder": "Cerca per nome, email o codice...",
    "sortBy": "Ordina per",
    "defaultSort": "Predefinito (Nome)",
    "nameAsc": "Nome (A-Z)",
    "nameDesc": "Nome (Z-A)",
    "surnameAsc": "Cognome (A-Z)",
    "emailAsc": "Email (A-Z)",
    "emailDesc": "Email (Z-A)",
    "roleAsc": "Ruolo (A-Z)",
    "roleDesc": "Ruolo (Z-A)",
    "noUsers": "Nessun utente disponibile",
    "showing": "Mostrando",
    "of": "di",
    "firstName": "Nome",
    "lastName": "Cognome",
    "role": "Ruolo",
    "roleSuper": "Super",
    "roleAdmin": "Admin",
    "roleSupervisor": "Supervisore",
    "roleUser": "Utente",
    "status": "Stato",
    "active": "Attivo",
    "inactive": "Inattivo",
    "verified": "Verificato",
    "pending": "In attesa",
    "lastLogin": "Ultimo accesso",
    "createSuccess": "Utente creato con successo",
    "createError": "Errore nella creazione dell'utente",
    "updateSuccess": "Utente aggiornato con successo",
    "deleteSuccess": "Utente eliminato con successo",
    "notVerified": "Utente non verificato",
    "notVerifiedDescription": "Questo utente non ha ancora verificato il proprio indirizzo email.",
    "resendVerification": "Reinvia email di verifica",
    "resending": "Reinvio in corso...",
    "emailSentSuccess": "Email inviata con successo",
    "basicInfo": "Informazioni di Base",
    "personalInfo": "Informazioni Personali",
    "assignments": "Assegnazioni",
    "code": "Codice",
    "primaryEmail": "Email Principale",
    "secondaryEmail": "Email Secondaria",
    "nationalId": "ID Nazionale",
    "birthDate": "Data di Nascita",
    "address": "Indirizzo",
    "account": "Account",
    "notSpecified": "Non specificato",
    "required": "*",
    "optional": "(opzionale)",
    "namePlaceholder": "Nome dell'utente",
    "surnamePlaceholder": "Cognome dell'utente",
    "emailPlaceholder": "utente@esempio.com",
    "email2Placeholder": "opzionale@esempio.com",
    "searchAccountPlaceholder": "Cerca account...",
    "roleRadiologist": "Radiologo",
    "roleRadiologistDesc": "Accesso base al sistema",
    "roleSupervisorDesc": "Supervisiona e rivede i referti",
    "roleAdminDesc": "Gestisce gli utenti nel proprio account",
    "roleSuperDesc": "Accesso completo al sistema",
    "nameRequired": "Il nome è obbligatorio",
    "nameMinLength": "Il nome deve contenere almeno 2 caratteri",
    "nameMaxLength": "Il nome è troppo lungo (massimo 100 caratteri)",
    "nameInvalidChars": "Il nome contiene caratteri non validi",
    "surnameRequired": "Il cognome è obbligatorio",
    "surnameMinLength": "Il cognome deve contenere almeno 2 caratteri",
    "surnameMaxLength": "Il cognome è troppo lungo (massimo 100 caratteri)",
    "surnameInvalidChars": "Il cognome contiene caratteri non validi",
    "emailRequired": "L'email è obbligatoria",
    "emailInvalid": "Il formato dell'email non è valido",
    "emailMaxLength": "L'email è troppo lunga (massimo 255 caratteri)",
    "email2Invalid": "Il formato dell'email secondaria non è valido",
    "email2MaxLength": "L'email secondaria è troppo lunga (massimo 255 caratteri)",
    "roleRequired": "Il ruolo è obbligatorio",
    "accountRequired": "L'account è obbligatorio",
    "saving": "Salvataggio...",
    "create": "Crea Utente",
    "createWithoutInvite": "Crea senza invitare",
    "update": "Aggiorna"
  },
  "accounts": {
    "title": "Account",
    "account": "account",
    "accountsPlural": "account",
    "accountList": "Elenco account",
    "addAccount": "Aggiungi account",
    "editAccount": "Modifica account",
    "accountDetails": "Dettagli account",
    "accountName": "Nome account",
    "accountType": "Tipo account",
    "newAccount": "Nuovo account",
    "management": "Gestione account",
    "subtitle": "Gestisci ospedali, utenti e licenze",
    "searchPlaceholder": "Cerca per nome o @dominio...",
    "sortBy": "Ordina per",
    "defaultSort": "Predefinito (Aggiornamento)",
    "nameAsc": "Nome (A-Z)",
    "nameDesc": "Nome (Z-A)",
    "newestFirst": "Più recenti",
    "oldestFirst": "Più vecchi",
    "recentlyModified": "Modificati di recente",
    "notModified": "Non modificati",
    "noAccounts": "Nessun account trovato",
    "tryDifferentSearch": "Prova altri termini di ricerca",
    "createFirstAccount": "Crea il tuo primo account per iniziare",
    "page": "Pagina",
    "of": "di",
    "domains": "Domini email",
    "noDomains": "Nessun dominio configurato",
    "licenseLimits": "Limiti licenze",
    "administrators": "Amministratori",
    "supervisors": "Supervisori",
    "radiologists": "Radiologi",
    "unlimited": "Illimitato",
    "metadata": "Metadati",
    "createdAt": "Creato il",
    "updatedAt": "Aggiornato il",
    "deleteConfirm": "Sei sicuro di voler eliminare questo account?",
    "deleteWarning": "Questa azione non può essere annullata ed eliminerà tutti i dati associati.",
    "deletion": {
      "title": "Eliminare l'account {{name}}",
      "lead": "L'eliminazione trascina tutto ciò che dipende dall'account. Non è reversibile.",
      "loading": "Calcolo dell'impatto...",
      "planFailed": "Impossibile calcolare l'impatto dell'eliminazione.",
      "groups": "gruppi",
      "usersToDelete": "utenti verranno eliminati",
      "usersToDeactivate": "utenti verranno disattivati (hanno storico clinico)",
      "gateways": "gateway verranno disattivati nell'Hub",
      "hubUnreachable": "L'Hub di integrazione non risponde. L'account non può essere eliminato senza disattivare prima i suoi gateway.",
      "confirm": "Eliminare a cascata",
      "success": "Account eliminato: {{groups}} gruppi, {{deleted}} utenti eliminati e {{deactivated}} disattivati."
    },
    "deleteSuccess": "Account eliminato con successo",
    "createSuccess": "Account creato con successo",
    "updateSuccess": "Account aggiornato con successo",
    "nameRequired": "Il nome è obbligatorio",
    "invalidNumber": "Deve essere un numero positivo",
    "invalidDomain": "Formato non valido. Deve essere come @dominio.com",
    "domainExists": "Questo dominio è già stato aggiunto",
    "addDomain": "Aggiungi dominio",
    "domainPlaceholder": "@esempio.com",
    "optional": "(Facoltativo, lascia vuoto per illimitato)",
    "generalInfo": "Informazioni Generali",
    "additionalInfo": "Informazioni aggiuntive",
    "creationDate": "Data di creazione",
    "lastUpdate": "Ultimo aggiornamento",
    "deleteAccount": "Eliminare account?",
    "deleteAccountMessage": "Questa azione eliminerà permanentemente l'account {name} e non può essere annullata.",
    "cancel": "Annulla",
    "confirmDelete": "Sì, elimina",
    "accountNameField": "Nome account",
    "requiredField": "*",
    "domainsDescription": "Aggiungi i domini email consentiti per questo account",
    "domainInputPlaceholder": "Es: @ospedale.com",
    "limitsDescription": "Definisci il massimo di utenti per ruolo",
    "maxAdmins": "Massimo amministratori",
    "maxSupervisors": "Massimo supervisori",
    "maxRadiologists": "Massimo radiologi",
    "packageTypeTitle": "Tipo di pacchetto",
    "packageTypeDescription": "Seleziona il livello di pacchetto per questo account",
    "packageType": "Pacchetto",
    "packageBronze": "Bronze",
    "packageSilver": "Silver",
    "packageGold": "Gold",
    "distributorTitle": "Distributore",
    "distributorDescription": "Seleziona il distributore associato a questo account. Puoi creare nuovi distributori.",
    "distributor": "Distributore",
    "hierarchy": {
      "title": "Struttura organizzativa",
      "manage": "Gestisci organizzazione",
      "manageHint": "Gruppi, team, modelli istituzionali e criteri, nel pannello di organizzazione."
    },
    "distributorDefault": "Predefinito",
    "distributorCreate": "Crea distributore…",
    "distributorCreatePlaceholder": "Es.: NUOVO_DISTRIBUTORE",
    "distributorNameRequired": "Inserisci un nome valido"
  },
  "groups": {
    "management": "Gestione gruppi",
    "subtitle": "Gestisci i gruppi medici della piattaforma",
    "newGroup": "Nuovo gruppo",
    "editGroup": "Modifica gruppo",
    "searchPlaceholder": "Cerca per nome o P.IVA...",
    "group": "gruppo",
    "groupsPlural": "gruppi",
    "noGroups": "Nessun gruppo trovato",
    "tryDifferentSearch": "Prova con altri termini di ricerca",
    "createFirstGroup": "Crea il tuo primo gruppo per iniziare",
    "generalInfo": "Informazioni Generali",
    "contactInfo": "Informazioni di Contatto",
    "accountInfo": "Informazioni Account",
    "code": "Codice",
    "groupName": "Nome del gruppo",
    "groupNamePlaceholder": "Es: Gruppo Diagnostico Nord",
    "nationalId": "P.IVA / C.F.",
    "nationalIdPlaceholder": "Es: IT12345678901",
    "address": "Indirizzo",
    "addressPlaceholder": "Es: Viale della Salute 45",
    "email": "Email di contatto",
    "emailPlaceholder": "Es: contatto@gruppo.com",
    "phone": "Telefono di contatto",
    "phonePlaceholder": "Es: +39 02 1234567",
    "account": "Account",
    "selectAccount": "Seleziona account...",
    "delete": "Elimina",
    "edit": "Modifica",
    "cancel": "Annulla",
    "saving": "Salvataggio...",
    "update": "Aggiorna",
    "create": "Crea gruppo",
    "deleteSuccess": "Gruppo eliminato con successo",
    "createSuccess": "Gruppo creato con successo",
    "updateSuccess": "Gruppo aggiornato con successo",
    "nameRequired": "Il nome è obbligatorio",
    "addressRequired": "L'indirizzo è obbligatorio",
    "emailRequired": "L'email è obbligatoria",
    "phoneRequired": "Il telefono è obbligatorio",
    "accountRequired": "L'account è obbligatorio",
    "invalidEmail": "Formato email non valido",
    "notSpecified": "Non specificato",
    "notAssigned": "Non assegnato",
    "close": "Chiudi",
    "loadError": "Errore nel caricamento dei gruppi"
  },
  "validation": {
    "required": "Questo campo è obbligatorio",
    "invalidEmail": "Email non valida",
    "passwordTooShort": "La password deve contenere almeno 8 caratteri",
    "passwordMismatch": "Le password non corrispondono",
    "invalidFormat": "Formato non valido"
  },
  "navigation": {
    "home": "Home",
    "dashboard": "Pannello",
    "reports": "referti",
    "templates": "Modelli",
    "users": "Utenti",
    "accounts": "Account",
    "settings": "Impostazioni"
  },
  "templates": {
    "title": "Modelli",
    "preparationNoticeLabel": "Ci sono modelli in fase di salvataggio.",
    "preparationNoticeHint": "Attendi prima di usare la dettatura.",
    "preparationNoticeDetail": "I modelli sono già stati salvati, ma sono ancora in preparazione per la dettatura. Attendi che questo avviso scompaia.",
    "viewAllTemplates": "Vedi tutti i modelli",
    "newTemplate": "Nuovo modello",
    "searchPlaceholder": "Cerca modello...",
    "allTypes": "Tutti i tipi",
    "allSources": "Tutte le origini",
    "allLanguages": "Tutti i linguaggi",
    "customSelect": "Seleziona lingua",
    "showing": "Mostrando",
    "template": "modello",
    "templates_plural": "modelli",
    "searching": "Ricerca modelli...",
    "loadingMore": "Caricamento altri modelli...",
    "empty": "Nessun modello trovato.",
    "emptyHint": "Aggiungi nuovi modelli",
    "newTemplateTitle": "Nuovo Modello",
    "details": "Dettagli",
    "selectTemplate": "Seleziona un modello…",
    "templateName": "Nome modello",
    "templateNameLabel": "Nome del Modello",
    "templatePlaceholder": "Es: RM_GINOCCHIO_CONTRASTO",
    "isBlock": "È un modello patologico?",
    "no": "No (Normale)",
    "yes": "Sì (Patologico)",
    "activationWord": "Parola di attivazione",
    "activationWordLabel": "Parola di attivazione",
    "activationWordPlaceholder": "Es: TUMORE, LESIONE, ecc.",
    "activationWordInfo": "La parola di attivazione permette di distinguere i modelli della stessa area anatomica. Ad esempio, per la pancreatite puoi usare 'PANCREATITE' per differenziarla da altri modelli del pancreas.",
    "autoUppercase": "Verrà convertito automaticamente in maiuscolo",
    "standard": "Standard",
    "defaultBadge": "Standard",
    "setDefault": "Usa «{{name}}» come modello standard",
    "unsetDefault": "Non usare più «{{name}}» come modello standard",
    "defaultSet": "«{{name}}» è ora il tuo modello standard",
    "defaultUnset": "Non hai più un modello standard personale",
    "defaultError": "Impossibile modificare il modello standard",
    "standardInfoTitle": "Modello Standard",
    "standardInfoBody": "",
    "standardInfoIntro": "Il modello standard è progettato per studi radiologici generali. Utilizza marcatori dinamici nella tecnica che vengono sostituiti automaticamente durante la generazione del referto.",
    "standardInfoTechniqueTitle": "Tecnica",
    "standardInfoTechniqueBody": "La tecnica include marcatori dinamici tra doppie parentesi quadre (come [[lateralità]], [[sequenze]], [[regioni_anatomiche]]) che il sistema sostituisce automaticamente con i valori corrispondenti nella generazione del referto.",
    "standardInfoTechniqueExample": "Si esegue TC [[regioni_anatomiche]] con tecnica elicoidale [[protocollo]].",
    "standardInfoFindingsTitle": "Reperti",
    "standardInfoFindingsBody": "I reperti sono redatti come testo descrittivo continuo in formato narrativo, descrivendo le strutture valutate e le loro caratteristiche.",
    "standardInfoUseCaseTitle": "Quando usarlo?",
    "standardInfoUseCaseBody": "Ideale per studi radiologici generali: TC delle estremità, RM del ginocchio, colonna vertebrale, addome, ecografie, radiografie, ecc.",
    "infoExample": "Es.:",
    "content": "3. Contenuto del Modello",
    "contentPlaceholder": "Trascina un file .txt qui o scrivi il contenuto...",
    "dragFile": "📄 Trascina un file .txt qui",
    "referenceIf": "4. Riferimento di Attivazione (REFERENCE_IF)",
    "alwaysActive": "Sempre attivo (ALWAYS)",
    "referenceIfWarning": "⚠️ Non possono esistere due REFERENCE_IF = ALWAYS per la stessa procedura",
    "activationWordRequired": "Parola di attivazione:",
    "activationWordInputPlaceholder": "Es.: PATOLOGIA, URGENTE...",
    "language": "Codice Lingua",
    "type": "Tipo",
    "saving": "Salvataggio...",
    "saveChanges": "Salva Modifiche",
    "createTemplate": "Crea Modello",
    "creating": "Creazione modello...",
    "nameRequired": "Il nome del modello è obbligatorio",
    "activationRequired": "Devi inserire una parola di attivazione per modelli patologici",
    "activationOrAlways": "Devi inserire una parola di attivazione o selezionare \"Sempre attivo\"",
    "supportsBilaterality": "ℹ️ Supporta unilateralità e bilateralità",
    "viewOtherTechnique": "Rivedi modello con bilateralità/unilateralità opposta",
    "relatedTechnique": "Tecnica correlata (Bilaterale/Unilaterale)",
    "contentRequired": "Il contenuto del modello non può essere vuoto",
    "techniqueRequired": "Il contenuto della tecnica non può essere vuoto",
    "findingsRequired": "Il contenuto dei reperti non può essere vuoto",
    "conclusionRequired": "Il contenuto della conclusione non può essere vuoto",
    "technique": "Tecnica",
    "techniquePlaceholder": "Scrivi il contenuto della tecnica",
    "techniquePlaceholderStandard": "Es: Si esegue RM del ginocchio [[lateralità]] [[sequenze]].",
    "findings": "Reperti",
    "findingsBlocks": "Reperti",
    "findingsPlaceholder": "Scrivi il contenuto dei reperti",
    "findingsPlaceholderStandard": "Es: Strutture ossee con segnale midollare normale, senza edema o lesioni focali.",
    "conclusion": "Conclusione",
    "conclusionPlaceholder": "Scrivi il contenuto della conclusione",
    "conclusionPlaceholderStandard": "Es: Esame senza reperti significativi.",
    "noProcedures": "Non esistono procedure associate al tuo modello",
    "templateCreated": "Modello creato con successo",
    "errorSaving": "Errore nel salvataggio del modello",
    "normal": "Normale",
    "pathology": "Patologia",
    "urgent": "Urgente",
    "followUp": "Follow-up",
    "pediatric": "Pediatrico",
    "USER": "Utente",
    "STANDARD": "Standard",
    "AINOVIS": "Ainovis",
    "procedureAssignment": "Assegna Procedure",
    "procedureAssignmentExplanation": "Quando generi un referto e viene rilevata una delle procedure assegnate, questo modello verrà automaticamente utilizzato per generare il referto.",
    "groupFull": "Gruppo pieno",
    "principal": "Principale",
    "complementary": "Complementare",
    "procedure": "Procedura",
    "addPrincipalFirst": "Aggiungi prima una procedura principale",
    "dragOrAssign": "Trascina o assegna procedure",
    "suggestedProcedures": "Procedure suggerite",
    "highRelevance": "Alta rilevanza",
    "mediumRelevance": "Media rilevanza",
    "assignAsPrincipal": "Assegna come Principale",
    "assignAsComplementary": "Assegna come Complementare",
    "confirmSelection": "Conferma selezione",
    "remove": "Rimuovi",
    "resolving": "Risoluzione modello con procedure...",
    "contentLabel": "Modello",
    "availableProcedures": "Procedure disponibili",
    "add": "Aggiungi",
    "assigned": "Assegnato",
    "dropHere": "Rilascia qui per creare un gruppo",
    "clickToAddProcedure": "Clicca o trascina una procedura per aggiungerla",
    "singleExample": "Singolo",
    "singleExampleValue": "Ginocchio → Una singola procedura",
    "multiExample": "Multi",
    "multiExampleValue": "Ginocchio + Gamba → Più procedure insieme",
    "expandList": "Espandi lista",
    "collapseList": "Comprimi lista",
    "activationReference": "Riferimento di attivazione",
    "alwaysActiveDesc": "Il modello si attiva sempre",
    "customReference": "Riferimento personalizzato",
    "customReferenceDesc": "Scrivi una parola chiave di attivazione",
    "customActivation": "Attivazione personalizzata",
    "selectDestination": "Seleziona destinazione",
    "whereToAdd": "Dove vuoi aggiungere",
    "addToExisting": "Aggiungi a esistente",
    "willCreateMulti": "Creerà una Multi-procedura",
    "willCreateSingle": "Creerà una Procedura singola",
    "full": "Pieno",
    "createNewSection": "Crea nuovo",
    "createNewProcedure": "Crea come Procedura singola",
    "assignedProcedures": "Procedure assegnate",
    "item": "elemento",
    "items": "elementi",
    "examples": "Esempi",
    "singleProcedure": "Procedura singola",
    "multiProcedure": "Multi-procedura",
    "collapse": "Comprimi",
    "expand": "Espandi",
    "dropToCreate": "Rilascia qui per creare nuovo",
    "templateContent": "Contenuto del modello",
    "block": "Patologico",
    "howToTemplates": "Come funzionano i modelli",
    "chipLegendSelector": "Selettore",
    "chipLegendPlaceholder": "Segnaposto",
    "chipInsertHint": "Fai clic su un campo o digita <kbd>/</kbd> per inserire",
    "stepConfigureTemplate": "Configura",
    "stepSelectMarkers": "Marcatori",
    "stepAssignProcedures": "Procedure",
    "analyzeTemplate": "Analizza modello",
    "assignProcedures": "Assegna procedure",
    "saveTemplate": "Salva modello",
    "blocksHint": "I modelli patologici richiedono solo reperti e una parola di attivazione. Tecnica e conclusione vengono omesse.",
    "normalHint": "I modelli normali includono tecnica, reperti e conclusione.",
    "standardHint": "Testo libero per descrivere i reperti senza struttura fissa.",
    "cancelConfirmTitle": "Annullare le modifiche?",
    "cancelConfirmMessage": "Hai modifiche non salvate. Cosa vuoi fare?",
    "discardChanges": "Annulla",
    "keepEditing": "Continua a modificare",
    "draftSaved": "Bozza salvata",
    "draftSavedJustNow": "Bozza salvata",
    "fieldRequired": "Questo campo è obbligatorio",
    "procedureStepIntro": "Passo 1: Clicca su una procedura per assegnarla.",
    "procedureStepGroup": "Passo 2: Se ci sono gruppi, scegli dove aggiungerla.",
    "procedureStepConfirm": "Passo 3: Conferma la selezione quando hai finito.",
    "confirmDelete": "Sei sicuro di voler eliminare questo modello? Tutte le versioni associate (bilaterale/unilaterale) e le loro relazioni con le procedure verranno rimosse.",
    "voiceChipTemplate": "Usa il modello",
    "voiceChipTemplatesHint": "Detta «Usa il modello ...» o seleziona",
    "copyAsPersonal": "Copia come personale",
    "copying": "Copiando...",
    "copySuccess": "Copiato!",
    "copyError": "Errore durante la copia del modello",
    "copyConflictTitle": "Conflitto di procedure",
    "copyConflictMessage": "Esistono già modelli personali per le procedure assegnate a questo modello:",
    "copyConflictHint": "Per utilizzare questo modello, devi assegnare una parola di attivazione per differenziarlo da quelli esistenti.",
    "copyWithActivation": "Copia con attivazione",
    "help": {
      "title": "Come creare modelli",
      "intro": "I modelli permettono di generare referti radiologici in modo rapido e coerente. Scrivi il testo base del referto e aggiungi <strong>campi variabili</strong> dove hai bisogno di valori dinamici.",
      "selectorTitle": "Selettore",
      "selectorDesc": "Definisce un elenco di opzioni possibili per un campo. Durante la generazione del referto, una di esse verrà scelta. Facoltativamente puoi indicare un <strong>valore predefinito</strong> che verrà utilizzato se non ne viene indicato un altro.",
      "exampleInEditor": "Esempio nell'editor:",
      "selectorExampleChip": "conservata / aumentata / diminuita: *conservata*",
      "selectorDetail": "Questo significa: le opzioni sono «conservata», «aumentata» e «diminuita». Se non viene specificato altro, <strong>«conservata»</strong> verrà usato come valore predefinito. Il default è opzionale — se non lo indichi, le opzioni verranno semplicemente mostrate senza un valore preselezionato.",
      "placeholderTitle": "Segnaposto",
      "placeholderDesc": "Un indicatore generico che verrà <strong>sostituito</strong> da un valore concreto nella generazione del referto (una descrizione, una misura, un riscontro, ecc.).",
      "placeholderExampleChip": "riscontro",
      "placeholderDetail": "Questo indicatore verrà sostituito dal testo corrispondente quando verrà generato il referto finale.",
      "tipTitle": "💡 Suggerimento",
      "tipText": "Digita <kbd>/</kbd> nell'editor per aprire il menu rapido di inserimento campi, o usa i pulsanti nella barra superiore di ogni sezione.",
      "ok": "Capito"
    },
    "all": "Tutti",
    "personal": "Personali",
    "source": "Origine",
    "galleryNormalPrefix": "Galleria di ",
    "galleryBlockPrefix": "Galleria di ",
    "galleryBlockSuffix": "",
    "gallerySubtitle": "Gestisci i tuoi modelli e blocchi di referto",
    "countShown": "{{count}} modelli",
    "countShown_one": "{{count}} modello",
    "countShown_other": "{{count}} modelli",
    "blocksCountShown": "{{count}} blocchi",
    "blocksCountShown_one": "{{count}} blocco",
    "blocksCountShown_other": "{{count}} blocchi",
    "blocksWord": "Blocchi",
    "templatesWord": "modelli",
    "myTemplates": "I tuoi modelli",
    "import": "Importa modello",
    "importTemplates": "Importa modelli",
    "importDropTitle": "Trascina qui un DOCX, un PDF o un TXT",
    "importDropActive": "Rilascia i file qui",
    "importDropHint": "Oppure fai clic per selezionare i file",
    "importAddMore": "Aggiungi altri file o continua",
    "importFilesCount": "{{count}} file",
    "importTotalSize": "{{count}} file · {{size}} di {{limit}}",
    "importTotalTooLarge": "La dimensione totale dei file supera il limite di {{limit}}",
    "importProcessingN": "Elaborazione del documento {{current}} di {{total}}…",
    "importFormats": "Formati supportati: .docx, .pdf, .txt · Max 25 MB in totale",
    "importInvalidFormat": "Formato non supportato. Usa un file .docx, .pdf o .txt",
    "importProcessing": "Elaborazione del documento…",
    "importSaving": "Importazione…",
    "importSaveFailed": "Non è stato possibile importare i modelli",
    "importPartialFailure": "Non è stato possibile importare: {{titles}}",
    "importDone": "{{created}} modelli creati e {{replaced}} sostituiti",
    "importSkippedAinovis": "Ignorati perché coincidono con modelli Ainovis: {{titles}}",
    "importFailed": "Non è stato possibile elaborare il documento",
    "importEmpty": "Nessun modello trovato nel documento.",
    "importRemoveFile": "Rimuovi file",
    "importSplitTitle": "Dividi documento",
    "importSplitHint": "Scegli come separare i modelli del documento.",
    "importSplitAi": "Rilevamento IA",
    "importSplitAiHint": "L'IA rileva ogni modello del documento.",
    "importSplitPageBreaks": "Interruzioni di pagina",
    "importSplitPageBreaksHint": "Un modello per ogni pagina del documento.",
    "importSplitHorizontalLine": "Linea orizzontale",
    "importSplitHorizontalLineHint": "Divide il documento a ogni linea orizzontale.",
    "importPreviewTitle": "Anteprima",
    "importFoundCount": "{{count}} modelli trovati",
    "importSplitBy": "Dividi per",
    "importNameLabel": "Nome del modello",
    "importWordCount": "{{count}} parole",
    "importNoConflict": "Non esiste alcun modello con questo nome.",
    "importReplaces": "Sostituisce «{{name}}»",
    "importAinovisConflict": "Esiste già un modello Ainovis con questo nome",
    "importAinovisConflictFull": "Esiste già un modello Ainovis con questo nome. Cambialo per poterlo importare.",
    "importDuplicateInDocument": "Nome ripetuto in questo documento",
    "importDuplicateInDocumentFull": "Un altro modello di questo documento usa già questo nome. Cambialo per poterlo importare.",
    "importEmptyName": "Assegna un nome per poterlo importare",
    "importUntitled": "Senza nome",
    "importBlocked": "Correggi {{count}} nome/i per importare",
    "importNameLabel": "Nome del modello",
    "importFilledPerReport": "Da compilare in ogni referto",
    "importSummary": "{{total}} di {{found}} selezionati",
    "importChooseAnother": "Scegli un altro file",
    "importConfirm": "Importa {{count}} modelli",
    "tabMine": "Personali",
    "tabShared": "Istituzionali",
    "tabAinovis": "Ainovis",
    "filterStandard": "Standard",
    "loading": "Caricamento modelli...",
    "editTitle": "Modifica modello",
    "saveEdit": "Salva modifiche",
    "filterSource": "Origine",
    "filterLanguage": "Lingua",
    "normalTab": "Modelli",
    "blocksTab": "Blocchi",
    "filters": "Filtri",
    "deleteTitle": "Eliminare il modello",
    "deleteConfirm": "Sei sicuro di voler eliminare <strong>{{name}}</strong>? Questa azione eliminerà tutte le versioni di questo modello e non può essere annullata.",
    "deleting": "Eliminazione…",
    "delete": "Elimina",
    "bulkDeleteTitle": "Elimina modelli",
    "bulkDeleteMessage": "Eliminare {{count}} modelli? Verranno eliminate tutte le loro versioni e l'azione non può essere annullata.",
    "selectedCount": "{{count}} selezionati",
    "selectTemplate": "Seleziona «{{name}}»",
    "tabNormal": "Modelli",
    "tabBlocks": "Blocchi",
    "previewLabel": "Anteprima:",
    "apply": "Applica",
    "cancel": "Annulla"
  },
  "recommendations": {
    "title": "Suggerimenti",
    "show": "Mostra suggerimenti",
    "hide": "Nascondi suggerimenti",
    "list": "Suggerimenti disponibili",
    "block": "Blocco",
    "classification": "Classificazione",
    "loading": "Caricamento suggerimenti…",
    "error": "Impossibile aggiornare tutti i suggerimenti.",
    "noTemplate": "Seleziona un modello per vedere i suggerimenti.",
    "empty": "Nessun utilizzo con questo modello.",
    "expandName": "Leggi il nome completo",
    "collapseName": "Comprimi il nome",
    "remove": "Rimuovi {{name}} dai suggerimenti"
  },
  "blocks": {
    "sectionContentPlaceholder": "Scrivi qui il contenuto che verrà inserito nella sezione...",
    "namePlaceholder": "Nome del blocco (es: Pancreatite acuta)",
    "createHint": "Questo contenuto verrà inserito nella sezione dove lo trascini.",
    "empty": "Nessun blocco",
    "createFirst": "Crea blocco",
    "createCard": "Crea blocco",
    "deleteTitle": "Elimina blocco",
    "deleteConfirm": "Sei sicuro di voler eliminare <strong>{{name}}</strong>? Questa azione non può essere annullata.",
    "deleting": "Eliminazione…",
    "delete": "Elimina",
    "cancel": "Annulla",
    "sidebarTitle": "Blocchi",
    "searchToPin": "Cerca blocco...",
    "noResults": "Nessun risultato",
    "expand": "Espandi",
    "collapse": "Chiudi",
    "addToTemplate": "Aggiungi",
    "unpin": "Sblocca",
    "pinnedLoadError": "I blocchi fissati non sono disponibili. Puoi comunque usare i blocchi.",
    "preview": "Anteprima",
    "removeAssociation": "Rimuovi dall'elenco"
  },
  "classificationCarousel": {
    "searchPlaceholder": "Cerca classificazione...",
    "empty": "Nessuna classificazione trovata",
    "descriptions": {
      "FLEISCHNER": "Follow-up dei noduli polmonari incidentali alla TC.",
      "TI-RADS": "Rischio di malignità dei noduli tiroidei all'ecografia.",
      "PI-RADS": "Sospetto di carcinoma prostatico clinicamente significativo alla RM.",
      "BOSNIAK_2019": "Stratificazione delle masse renali cistiche con TC o RM.",
      "GARDEN": "Fratture sottocapitate del collo del femore in base alla dislocazione.",
      "EATON_LITTLER": "Stadiazione della rizoartrosi trapeziometacarpale.",
      "SNYDER": "Lesioni complete della cuffia dei rotatori per dimensione e tendini coinvolti.",
      "HERBERT_FISCHER": "Fratture dello scafoide in base a stabilità ed evoluzione."
    }
  },
  "classificationRequest": {
    "title": "Richiedi classificazione",
    "close": "Chiudi",
    "successTitle": "Grazie per la tua richiesta!",
    "successSub": "Esamineremo il tuo suggerimento e lavoreremo per aggiungere la classificazione.",
    "intro": "Ritieni che manchi una classificazione? Dicci quale ti serve e la valuteremo per aggiungerla.",
    "descriptionLabel": "Descrivi la classificazione di cui hai bisogno",
    "descriptionPlaceholder": "Indica il nome della classificazione, la specialità o il tipo di studio in cui viene utilizzata e qualsiasi dettaglio rilevante...",
    "submitError": "Impossibile inviare la richiesta. Riprova.",
    "allowContact": "Accetto che il team Ainovis mi contatti per maggiori dettagli",
    "disclaimer": "Utilizzeremo queste informazioni esclusivamente per valutare e sviluppare nuove classificazioni.",
    "submitting": "Invio in corso…",
    "submit": "Invia richiesta",
    "requestClassification": "Richiedi classificazione"
  },
  "keyboardShortcuts": {
    "title": "Scorciatoie da tastiera",
    "close": "Chiudi",
    "groupDictation": "Dettatura",
    "dictationStart": "Avvia registrazione",
    "dictationSend": "Invia audio",
    "dictationSendAlt": "Invia audio",
    "dictationPauseResume": "Metti in pausa / riprendi dettatura",
    "dictationCancel": "Annulla audio",
    "groupTextFormat": "Formattazione testo",
    "bold": "Grassetto",
    "italic": "Corsivo",
    "underline": "Sottolineato",
    "strikethrough": "Barrato",
    "groupAlignment": "Allineamento",
    "alignLeft": "Allinea a sinistra",
    "alignCenter": "Centra",
    "alignRight": "Allinea a destra",
    "justify": "Giustifica",
    "groupEditing": "Modifica",
    "undo": "Annulla",
    "redo": "Ripristina",
    "selectAll": "Seleziona tutto",
    "copy": "Copia",
    "cut": "Taglia",
    "paste": "Incolla",
    "save": "Salva",
    "groupIndent": "Rientro",
    "indent": "Aumenta rientro",
    "unindent": "Riduci rientro",
    "groupView": "Vista",
    "zoomIn": "Ingrandisci",
    "zoomOut": "Riduci",
    "zoomReset": "Reimposta zoom",
    "key_space": "Spazio",
    "key_enter": "Invio",
    "key_esc": "Esc",
    "key_tab": "Tab",
    "key_shift": "Maiusc"
  },
  "aiSidebar": {
    "title": "Carolina",
    "newChat": "Nuova chat",
    "closePanel": "Chiudi pannello IA",
    "heroText": "Chiedimi qualsiasi dubbio tu abbia su Ainovis",
    "inputPlaceholder": "Scrivi un messaggio...",
    "errorMessage": "Mi dispiace, non sono riuscito a elaborare la tua domanda. Riprova.",
    "question1": "Come genero un referto con la SmartBar?",
    "question2": "Come avvio la dettatura vocale?",
    "question3": "Quali classificazioni mediche posso usare?"
  },
  "diffModal": {
    "badge": "Conversione in modello",
    "progressOptions": "opzioni",
    "title": "Marcatori rilevati nel testo",
    "subtitle": "Rivedi le modifiche proposte per convertire questo report in un modello riutilizzabile",
    "closeLabel": "Chiudi modale",
    "selectMarkers": "Seleziona marcatori",
    "slotsTitle": "Opzioni di costruzione del modello",
    "slotsSubtitle": "Seleziona quali marcatori applicare. I testi corrispondenti verranno sostituiti.",
    "globalMode": "Modalità Globale",
    "individualMode": "Modalità Individuale",
    "useGlobalMarker": "Usa marcatore globale",
    "globalMarkerDescription": "Applicherà lo stesso marcatore a tutte le regioni anatomiche",
    "finalResult": "Risultato finale",
    "previewBadge": "Anteprima",
    "defaultValue": "Valore predefinito",
    "unspecified": "Non specificato",
    "defaultHint": "Le parti evidenziate usano valori predefiniti. Seleziona tutte le opzioni per confermare.",
    "infoTitle": "Cosa sono i marcatori?",
    "infoDescription": "I marcatori (es: [regione anatomica], [lateralità]) sono campi che verranno compilati automaticamente quando si utilizza questo modello, consentendone il riutilizzo per casi diversi.",
    "warningTitle": "Completa tutte le selezioni",
    "warningDescription": "Mancano {count} opzioni da selezionare. Gli slot non selezionati sono evidenziati.",
    "keepOriginal": "Mantieni originale",
    "applyTemplate": "Applica modello",
    "lateralityDisabledByRegion": "Le lateralità sono disabilitate perché le regioni anatomiche le includono già",
    "regionDisabledByLaterality": "Le regioni anatomiche sono disabilitate perché ci sono lateralità selezionate",
    "flexibilityTitle": "Modello più flessibile",
    "flexibilityDescription": "Scegliendo i marcatori, il tuo report sarà più versatile. I campi marcati verranno compilati automaticamente in base alla procedura, permettendoti di riutilizzare questo modello per più casi senza modifiche manuali.",
    "noMarkersTitle": "Nessun marcatore selezionato",
    "noMarkersDescription": "Seleziona almeno un marcatore per applicare modifiche alla tecnica, oppure continua per usare il testo originale.",
    "replace": "Sostituire",
    "insert": "Inserire"
  },
  "editor": {
    "sectionTitleEditToast": "Ricorda che puoi modificare i titoli predefiniti dalle impostazioni"
  },
  "errors": {
    "authInvalidCredentials": "Email o password errati",
    "authInvalidToken": "Sessione non valida o scaduta",
    "authTokenExpired": "La tua sessione è scaduta. Effettua nuovamente l'accesso",
    "authMissingToken": "Devi effettuare l'accesso per accedere",
    "authUserNotFound": "Utente non trovato",
    "authUserAlreadyExists": "Questo utente esiste già",
    "authInactiveUser": "Il tuo account è disattivato. Contatta l'amministratore",
    "authInsufficientPermissions": "Non hai permessi sufficienti per questa azione",
    "authValidationError": "Errore nella convalida dei dati",
    "validationError": "Verifica i dati inseriti",
    "templateNotFound": "Modello non trovato",
    "templateValidationError": "Errore nei dati del modello",
    "templateRetrievalError": "Errore nel recupero dei modelli",
    "templateAlreadyExists": "Esiste già un modello con quel nome",
    "templateNameDuplicate": "Esiste già un modello con quel nome per questo utente",
    "templateReferenceIfConflictAlways": "Esiste già un modello \"{{templateName}}\" per la combinazione di procedure: {{procedureNames}}. Può esistere solo un modello predefinito per combinazione di procedure.",
    "templateReferenceIfConflict": "Esiste già un modello \"{{templateName}}\" con la parola di attivazione \"{{referenceIf}}\" per la combinazione di procedure: {{procedureNames}}. Per favore, usa una parola di attivazione diversa.",
    "templateNoTemplatesFound": "Nessun modello trovato per questo utente",
    "templateInvalidFormat": "Formato modello non valido",
    "templateAccessDenied": "Non hai accesso a questo modello",
    "blockLimitReached": "Hai raggiunto il limite di {{limit}} blocchi. Eliminane uno per crearne un altro.",
    "reportNotFound": "Report non trovato",
    "reportValidationError": "Errore nei dati del report",
    "reportGenerationError": "Errore nella generazione del report",
    "reportSaveError": "Errore nel salvataggio del report",
    "reportAlreadyExists": "Esiste già un report con quell'identificatore",
    "reportRetrievalError": "Errore nel recupero dei report",
    "reportModalityNotFound": "La modalità selezionata non esiste",
    "reportAccessDenied": "Non hai accesso a questo report",
    "reportDataInvalid": "I dati del report non sono validi",
    "reportMissingField": "Campi obbligatori mancanti nel report",
    "reportInvalidFormat": "Formato report non valido",
    "reportInvalidGenerationRequest": "Richiesta di generazione non valida",
    "reportApiError": "Errore di connessione al servizio report",
    "reportServiceError": "Errore nel servizio report",
    "reportAlignmentError": "Errore durante l'allineamento del report",
    "reportNoModalityOrRegions": "Impossibile rilevare modalità o regioni anatomiche nel testo",
    "reportTemplatesNotFoundForProcedure": "Nessun modello trovato per la tua procedura e lingua",
    "reportTemplatesFoundForDifferentType": "Non sono stati trovati modelli del tipo richiesto per la tua procedura, ma esistono modelli di tipo {{availableType}}",
    "reportTemplateType_STANDARD": "referti all'inizio o referti nel testo",
    "reportsTemplateNotFound": "Nessun modello disponibile per questo descrittivo. Puoi crearne uno per utilizzarlo",
    "reportsTemplateIncomplete": "Il modello è incompleto e non può essere utilizzato per generare il report",
    "reportsTemplateContentNotFound": "Contenuto del modello non trovato",
    "reportsTemplateContentIncomplete": "Il contenuto del modello è incompleto",
    "reportsPromptNotFound": "Il prompt necessario per la generazione non è stato trovato",
    "reportsFindingsGenerationError": "Errore nella generazione dei risultati del report",
    "reportsConclusionGenerationError": "Errore nella generazione della conclusione del report",
    "reportsSectionGenerationError": "Errore nella generazione di una sezione del report",
    "reportsParallelGenerationError": "Errore durante la generazione parallela del report",
    "reportsInvalidGenerationParameters": "Parametri di generazione non validi",
    "reportsAlignmentError": "Errore durante l'allineamento del report",
    "reportsPreSaveReviewError": "Errore nella revisione pre-salvataggio",
    "reportsLlmServiceError": "Errore nel servizio di intelligenza artificiale",
    "reportLanguageCodeNotFound": "Il codice lingua richiesto non è stato trovato",
    "reportInactiveTemplate": "Il modello selezionato è inattivo",
    "reportProcedureNotFound": "La procedura richiesta non è stata trovata",
    "reportAnatomicalRegionNotFound": "La regione anatomica richiesta non è stata trovata",
    "reportVariantNotFound": "La variante richiesta non è stata trovata",
    "reportTemplateNotFound": "Modello del report non trovato",
    "ainovisApiError": "Errore nel servizio IA",
    "ainovisConnectionError": "Errore di connessione con il servizio IA",
    "ainovisTimeoutError": "Il servizio IA ha impiegato troppo tempo a rispondere",
    "ainovisInvalidAudioFormat": "Formato audio non valido",
    "ainovisAudioFileSizeExceeded": "Il file audio è troppo grande",
    "ainovisMissingAudioFile": "Nessun file audio fornito",
    "sttServiceError": "Errore nel servizio di trascrizione",
    "sttValidationError": "Errore nella convalida dei dati di trascrizione",
    "sttMissingField": "Campi obbligatori mancanti per la trascrizione",
    "sttProcessingError": "Errore nell'elaborazione dell'audio",
    "sttApiError": "Errore di connessione al servizio di trascrizione",
    "sttNoVoiceDetected": "Nessuna voce rilevata nell'audio",
    "sttAudioProcessingError": "Errore nell'elaborazione del file audio",
    "sttNoAudioChunks": "Nessun frammento audio valido generato",
    "sttTranscriptionError": "Errore nella trascrizione vocale",
    "sttNoTranscriptionResults": "Nessun risultato di trascrizione ottenuto",
    "sttEmptyTranscript": "La trascrizione è risultata vuota",
    "sttInvalidAudioFile": "Il file audio non è valido o è corrotto",
    "sttAudioFormatNotSupported": "Il formato audio non è supportato",
    "emailSendFailed": "Errore nell'invio dell'email",
    "emailInvalidConfig": "Configurazione email non valida",
    "emailInvalidAddress": "Indirizzo email non valido",
    "emailTemplateNotFound": "Modello email non trovato",
    "emailTemplateRenderError": "Errore nel rendering dell'email",
    "emailConnectionError": "Errore di connessione al server email",
    "emailAuthenticationError": "Errore di autenticazione con il server email",
    "networkError": "Errore di connessione. Verifica la tua connessione internet",
    "noResponse": "Il server non risponde. Riprova",
    "requestSetupError": "Errore nell'elaborazione della richiesta",
    "unexpectedError": "Si è verificato un errore imprevisto"
  },
  "billing": {
    "studies": "Studi",
    "revenue": "Fatturato (€)",
    "modality": {
      "rx": "Radiografia",
      "eco": "Ecografia",
      "tc": "TC",
      "rm": "RM"
    }
  },
  "statistics": {
    "dateRange": "Gen 15 – Feb 15, 2026",
    "sections": {
      "productionVolume": "Produzione e volume",
      "performanceEfficiency": "Prestazioni ed efficienza",
      "billing": "Fatturazione",
      "realtimeActivity": "Attività in tempo reale"
    },
    "kpi": {
      "reportsToday": "Report oggi",
      "activeRadiologists": "Radiologi attivi",
      "averageTime": "Tempo medio",
      "templateUsage": "Utilizzo modelli",
      "vsYesterday": "12.3% vs ieri",
      "thisWeek": "+2 questa settimana",
      "vsAvg": "0.8 min vs med.",
      "thisMonth": "5% questo mese"
    },
    "charts": {
      "reportsPerMonth": "Report generati al mese",
      "reportsPerMonthSubtitle": "Ultimi 30 giorni — Totale: 22.487",
      "reportsPerMonthBadge": "+18% mensile",
      "billing": "Fatturazione per modalità",
      "billingSubtitle": "Tariffa oro · Volume e fatturato",
      "billingBadge": "🪩 Tariffa oro",
      "billingMonthly": "Tendenza dei ricavi mensili",
      "billingMonthlySubtitle": "Ultimi 6 mesi · Ricavi per modalità",
      "topRadiologists": "Metriche per radiologo",
      "topRadiologistsSubtitle": "Referti questa settimana per radiologo",
      "mostUsedTemplates": "Procedure più riportate",
      "mostUsedTemplatesSubtitle": "Distribuzione per tipo",
      "anatomicalRegions": "Referti per procedura",
      "anatomicalRegionsSubtitle": "Numero di referti per procedura",
      "heatmap": "Confronto per radiologo",
      "heatmapSubtitle": "Referti per radiologo e modalità",
      "reportsByModality": "Report per modalità",
      "reportsByModalitySubtitle": "Distribuzione statistica (box plot)",
      "timePerRadiologist": "Tempo di generazione per radiologo",
      "timePerRadiologistSubtitle": "Min. medio vs volume",
      "correlationMatrix": "Matrice di correlazione diagnostica",
      "correlationMatrixSubtitle": "Concordanza Pearson tra radiologi (20 studi)",
      "correlationLegend": "Coefficiente di correlazione (Pearson)",
      "frequentFindings": "Reperti frequenti",
      "frequentFindingsSubtitle": "Frequenza per tipo di reperto",
      "weeklyComparison": "Confronto settimanale",
      "weeklyComparisonSubtitle": "Top 5 — Attuale vs precedente",
      "realtimeFeed": "Feed in tempo reale",
      "realtimeFeedSubtitle": "Ultimi report",
      "live": "In diretta",
      "average": "Media",
      "reports": "report",
      "currentMonth": "Mese attuale",
      "previousMonth": "Mese precedente",
      "currentWeek": "Settimana attuale",
      "previousWeek": "Settimana precedente",
      "reportsLabel": "Report",
      "avgMinutes": "Min. medio",
      "volume": "Volume",
      "timeMins": "Tempo (min)",
      "time": "Tempo"
    },
    "days": {
      "mon": "Lun",
      "tue": "Mar",
      "wed": "Mer",
      "thu": "Gio",
      "fri": "Ven",
      "sat": "Sab",
      "sun": "Dom"
    },
    "specialties": {
      "neuroradiology": "Neuroradiologia",
      "musculoskeletal": "Muscoloscheletrico",
      "chest": "Torace",
      "abdomen": "Addome",
      "breast": "Mammella"
    },
    "templateNames": {
      "ctBrain": "TC Encefalo",
      "xrayChest": "RX Torace",
      "mriKnee": "RM Ginocchio",
      "ctAbdomen": "TC Addome",
      "usThyroid": "Eco Tiroide",
      "other": "Altro"
    },
    "regions": {
      "head": "Testa",
      "chest": "Torace",
      "abdomen": "Addome",
      "spine": "Colonna",
      "extremities": "Estremità",
      "pelvis": "Bacino"
    },
    "findings": {
      "noFindings": "Nessun reperto",
      "pulmonaryNodule": "Nodulo polmonare",
      "discHerniation": "Ernia del disco",
      "pleuralEffusion": "Versamento pleurico",
      "fracture": "Frattura",
      "renalMass": "Massa renale",
      "aneurysm": "Aneurisma",
      "stenosis": "Stenosi",
      "calcification": "Calcificazione",
      "hepaticCyst": "Cisti epatica"
    },
    "feed": {
      "minAgo": "{{value}} min fa"
    },
    "additionalTemplate": {
      "title": "Genera versione complementare",
      "infoBanner": "È stato rilevato che questo modello potrebbe avere una versione complementare (bilaterale/unilaterale). A sinistra, indica che tipo di versione stai scrivendo qui. Il modello originale verrà salvato automaticamente come la versione opposta. Ad esempio, se scegli 'Unilaterale', ciò che scrivi qui sarà la versione unilaterale e il modello originale verrà salvato come bilaterale.",
      "selectVersion": "Che tipo di versione è?",
      "selectionHint": "Indica se la versione complementare che stai scrivendo è bilaterale o unilaterale.",
      "bilateral": "Bilaterale",
      "bilateralDescription": "La versione complementare si applica a entrambi i lati (entrambe le ginocchia, entrambe le spalle, ecc.)",
      "unilateral": "Unilaterale",
      "unilateralDescription": "La versione complementare si applica a un solo lato con etichetta [lateralità].",
      "selectedVersion": "Versione {{option}} selezionata",
      "noSelection": "Seleziona un tipo di versione",
      "editContent": "Contenuto della versione complementare",
      "edited": "Modificato",
      "editHint": "Modifica i campi per definire il contenuto della versione complementare. Questo sarà il contenuto che verrà salvato.",
      "technique": "Tecnica",
      "techniquePlaceholder": "Scrivi la tecnica della versione complementare...",
      "findings": "Reperti",
      "findingsPlaceholder": "Scrivi i reperti della versione complementare...",
      "impression": "Conclusione",
      "impressionPlaceholder": "Scrivi la conclusione della versione complementare...",
      "skipGeneration": "Continua senza aggiuntivo",
      "save": "Salva versione"
    }
  },
  "onboarding": {
    "skip": "Salta",
    "next": "Avanti",
    "previous": "Indietro",
    "finish": "Capito!",
    "tryIt": "Provalo!",
    "example": "Esempio",
    "interactionPending": "Scrivi nell'editor per continuare",
    "interactionDone": "Perfetto! Puoi continuare",
    "welcomeTitle": "Benvenuto su Ainovis!",
    "welcomeDesc": "Sembra che sia la tua prima volta qui. Vuoi fare un tour rapido per conoscere gli strumenti principali?",
    "skipTour": "Non ora",
    "startTour": "Inizia il tour",
    "reportCreate": {
      "editorTitle": "Editor di dettatura",
      "editorDesc": "Qui apparirà la tua dettatura. Puoi digitare direttamente o usare il microfono per dettare lo studio.",
      "micTitle": "Dettatura vocale",
      "micDesc": "Premi il microfono per avviare la dettatura vocale. Il microfono funziona nella lingua dell'applicazione. Se non ti senti a tuo agio, puoi cambiare la lingua nelle impostazioni.",
      "generateTitle": "Genera referto",
      "generateDesc": "Una volta dettata o scritta la descrizione dello studio, premi questo pulsante per generare automaticamente il referto.",
      "modeTitle": "Modalità automatica / manuale",
      "modeDesc": "Alterna tra modalità automatica (Ainovis seleziona il modello) e manuale (scegli tu il modello da usare).",
      "speedModeTitle": "Velocità di generazione",
      "speedModeDesc": "Scegli tra modalità veloce (minore latenza) o precisa (maggiore qualità nella generazione del referto).",
      "settingsTitle": "Impostazioni del referto",
      "settingsDesc": "Configura la lingua, il tipo di modello e il tipo di conclusione prima di generare il referto.",
      "tryRomTitle": "Ora provalo tu!",
      "tryRomDesc": "Scrivi nell'editor una risonanza magnetica (RM) del ginocchio. Puoi copiare l'esempio o scrivere quello che preferisci. Questo ti mostrerà come Ainovis genera un referto.",
      "tryRomHint": "Scrivi una RM del ginocchio...",
      "tryRomExample": "RM del ginocchio. Normale",
      "tryGenerateTitle": "Genera il tuo primo referto!",
      "tryGenerateDesc": "Ora premi il pulsante di invio per generare il referto. Ainovis elaborerà ciò che hai scritto e creerà un referto completo."
    },
    "reportEdit": {
      "lateralMenuTitle": "Menu laterale",
      "lateralMenuDesc": "In questo pannello laterale troverai i parametri del referto. Se vieni dalla schermata di creazione, le impostazioni che hai configurato (lingua, tipo di modello, modalità) saranno già applicate qui.",
      "lateralMenuParamsTitle": "Rigenera con nuovi parametri",
      "lateralMenuParamsDesc": "Da qui puoi cambiare la lingua, il tipo di referto, il tipo di conclusione o la velocità e rigenerare il referto con i nuovi parametri. Puoi anche creare nuove versioni direttamente.",
      "patientBannerTitle": "Dati del paziente",
      "patientBannerDesc": "Qui puoi associare i dati del paziente al referto: nome, ID, età, sesso, data dello studio e motivo della visita. Puoi anche accedere agli studi precedenti del paziente per confrontare o riutilizzare referti precedenti.",
      "mainEditorTitle": "Editor del referto",
      "mainEditorDesc": "Questo è l'editor principale dove viene visualizzato il referto generato, diviso in sezioni (Tecnica, Reperti, Conclusione). Puoi modificare liberamente il testo, dettare a voce, e le modifiche vengono salvate automaticamente come bozza.",
      "versionTabsTitle": "Versioni del referto",
      "versionTabsDesc": "Ogni volta che rigeneri il referto o crei un foglio bianco, viene creata una nuova versione. Le schede in basso ti permettono di navigare tra le versioni, chiudere quelle non necessarie o creare una nuova versione vuota con il pulsante +.",
      "actionsTitle": "Azioni del referto",
      "actionsDesc": "Usa 'Copia' per copiare il referto negli appunti, 'Invia' per salvare il referto come definitivo, o 'Elimina' per scartare completamente la bozza."
    },
    "home": {
      "welcomeTitle": "Il tuo pannello di controllo",
      "welcomeDesc": "Questo è il tuo pannello principale. Da qui puoi creare nuovi referti, caricare audio per la dettatura in batch e accedere a tutta la tua cronologia di lavoro.",
      "createBtnTitle": "Crea referto",
      "createBtnDesc": "Premi questo pulsante per creare un nuovo referto da zero. Si aprirà l'editor dove potrai dettare o digitare lo studio.",
      "uploadBtnTitle": "Carica audio",
      "uploadBtnDesc": "Carica file audio con più dettature. Ainovis li trascriverà e separerà automaticamente in studi individuali.",
      "performanceTitle": "Riepilogo attività",
      "performanceDesc": "Qui puoi vedere le tue statistiche: referti creati, tempo risparmiato e tendenze di produttività. Premi 'Vedi più statistiche' per accedere al pannello completo.",
      "templatesTitle": "Modelli",
      "templatesDesc": "La scheda Modelli raccoglie i tuoi modelli di referto completi, pronti da usare quando generi un referto. Puoi crearne di nuovi, modificarne di esistenti o usare quelli condivisi dal tuo team.",
      "blocksTitle": "Blocchi",
      "blocksDesc": "Passa alla scheda Blocchi: qui vedi i blocchi, frammenti riutilizzabili (paragrafi, reperti, descrizioni) da inserire in qualsiasi referto per scrivere più velocemente.",
      "reportListTitle": "Cronologia di lavoro",
      "reportListDesc": "Qui troverai tutte le tue bozze, i referti salvati, i referti condivisi con te e i lotti di dettatura. Usa le schede per filtrare."
    },
    "reportEditV2": {
      "smartBarTitle": "SmartBar — La tua barra intelligente",
      "smartBarDesc": "La SmartBar è il tuo strumento principale. Digita il testo descrittivo dello studio o detta a voce e premi invio per generare automaticamente il referto con Carolina. Puoi anche usarla per modificare sezioni specifiche.",
      "canvasTitle": "Editor del referto",
      "canvasDesc": "Questo è l'editor principale dove viene visualizzato il referto generato, diviso in sezioni modificabili. Puoi modificare liberamente il testo e le modifiche vengono salvate automaticamente.",
      "toolbarTitle": "Barra degli strumenti",
      "toolbarDesc": "Personalizza la formattazione del testo: font, dimensione, grassetto, corsivo, allineamento, elenchi e altro. Funziona come qualsiasi editor di testo arricchito.",
      "findingsModeTitle": "Modalità di redazione",
      "findingsModeDesc": "Qui scegli come vengono redatti i riscontri: «Riscontri all'inizio» li raggruppa in alto, sopra il testo normale; «Riscontri nel testo» li integra nel corpo del referto. Puoi cambiare modalità in qualsiasi momento.",
      "menuBarTitle": "Barra dei menu",
      "menuBarDesc": "Accedi a tutte le funzioni: gestione file, inserimento elementi (immagini, tabelle, grafici), classificazioni mediche, modelli e supporto.",
      "classificationsTitle": "Classificazioni mediche",
      "classificationsDesc": "Accedi a classificazioni standardizzate come Fleischner, TI-RADS, PI-RADS, Bosniak e altre. Seleziona i parametri e la classificazione verrà inserita automaticamente nel tuo referto.",
      "versionsTitle": "Cronologia versioni",
      "versionsDesc": "Questa è la cronologia delle versioni del referto. Ogni invio, rigenerazione o applicazione di un modello salva qui una versione. I passaggi che hanno modificato ciascuna versione sono raggruppati per data, così puoi confrontare, visualizzare in anteprima e ripristinare qualsiasi versione precedente.",
      "patientsTitle": "Pazienti",
      "patientsDesc": "Da questo pannello cerchi e associ il paziente dell'esame. Una volta selezionato, i suoi dati e i suoi esami precedenti restano collegati al referto per consultarli o riutilizzare referti anteriori.",
      "patientsNotIntegrated": "Questa funzionalità non è ancora integrata. Per vedere i dati e la cronologia del paziente, il referto deve essere aperto da un sistema esterno (RIS/PACS).",
      "reportsHistoryTitle": "Referti precedenti",
      "reportsHistoryDesc": "Qui vedi la cronologia dei referti salvati e puoi consultarli per confrontare i reperti con esami antecedenti.",
      "micQrTitle": "Microfono del cellulare",
      "micQrDesc": "Scansiona questo codice con il cellulare per usarlo come microfono per la dettatura wireless. Il codice scade dopo un po'; se si disconnette, rigeneralo da qui.",
      "aiBtnTitle": "Assistente IA — Carolina",
      "aiBtnDesc": "Apri il pannello di Carolina, la tua assistente IA. Puoi farle domande sul referto, chiedere suggerimenti o consultare dubbi medici correlati.",
      "testTemplateTitle": "Crea il tuo primo modello",
      "testTemplateDesc": "Fai clic sulla scheda « CREARE MODELLO »: compileremo noi il nome e un referto di esempio.",
      "testTemplateSaveTitle": "Salva il tuo modello",
      "testTemplateSaveDesc": "Il modello è già compilato con un referto RM del ginocchio di esempio. Premi « Salva modello » per terminare.",
      "testTemplatePending": "Salva il modello per continuare",
      "autoFillTemplateName": "Test RM ginocchio",
      "autoFillTemplateSectionTechnique": "TECNICA",
      "autoFillTemplateTechniqueBody": "Studio RM del ginocchio destro con sequenze DP FS e T1 nei tre piani, senza somministrazione di mezzo di contrasto.",
      "autoFillTemplateSectionFindings": "RITROVAMENTI",
      "autoFillTemplateFindingsBody": "Menischi di morfologia e intensità di segnale normali, senza evidenza di rottura. Legamenti crociati e collaterali integri. Cartilagine articolare conservata. Non si osserva versamento articolare significativo. Segnale midollare osseo normale.",
      "autoFillTemplateSectionConclusion": "CONCLUSIONE",
      "autoFillTemplateConclusionBody": "Studio RM del ginocchio destro nei limiti della norma.",
      "testBlockTitle": "Crea il tuo primo blocco",
      "testBlockDesc": "Fai clic sulla scheda « Crea blocco »: compileremo noi un frammento riutilizzabile di esempio. Ti basterà premere « Salva ».",
      "testBlockPending": "Salva il blocco per continuare",
      "autoFillBlockName": "Rottura del menisco mediale",
      "autoFillBlockContent": "Rottura orizzontale del corno posteriore del menisco mediale, con estensione alla superficie articolare inferiore.",
      "testReportTitle": "Detta il tuo primo referto a Carolina",
      "testReportDesc": "Premi il microfono e pronuncia ad alta voce il comando qui sotto. È così che lavorerai ogni giorno: parlando, non scrivendo.",
      "testReportPending": "Pronuncia il comando ad alta voce per continuare",
      "voiceGateIdle": "Premi il microfono e pronuncia il comando ad alta voce.",
      "voiceGateSayThis": "Pronuncia ad alta voce:",
      "voiceGateNoMic": "Non posso usare il microfono",
      "voiceGatePlaceholder": "Usa il microfono →",
      "voiceGateChecking": "Sto ascoltando quello che hai detto…",
      "voiceGateHeard": "Ho capito:",
      "voiceGateMissingTemplate": "Manca il nome del tuo modello.",
      "voiceGateMissingBlock": "Manca il nome del tuo blocco.",
      "voiceGateRetry": "Ripeti il comando esattamente come appare sopra.",
      "voiceGateTypeFallback": "Puoi anche scriverlo nella barra.",
      "voiceGateError": "Non è stato possibile trascrivere l'audio. Riprova.",
      "testReportExample": "Usa il modello {{template}} e aggiungi il blocco {{block}}"
    }
  },
  "voiceHelp": {
    "title": "Comandi vocali",
    "intro": "Durante la registrazione puoi usare comandi vocali per modificare il referto. Puoi anche semplicemente dettare il testo e verrà inserito nella posizione del cursore. Ecco i comandi disponibili:",
    "deleteTitle": "Cancellare testo",
    "deleteDesc": "Rimuove testo dal referto. Puoi specificare una sezione particolare.",
    "deleteEx1": "Cancella il paziente presenta dolore",
    "deleteEx2": "Elimina nella sezione reperti la massa epatica",
    "updateTitle": "Modificare testo",
    "updateDesc": "Sostituisce un testo con un altro. Usa 'con' per indicare il nuovo valore.",
    "updateEx1": "Cambia paziente con individuo",
    "updateEx2": "Sostituisci nella sezione tecnica sequenza FLAIR con sequenza T2",
    "insertTitle": "Inserire testo",
    "insertDesc": "Aggiunge nuovo testo al referto. Puoi indicare una sezione o una posizione relativa (prima/dopo).",
    "insertEx1": "Inserisci il paziente presenta buone condizioni generali",
    "insertEx2": "Aggiungi nella sezione reperti massa di 3 cm",
    "insertEx3": "Inserisci nella sezione tecnica con sequenze in T1 dopo RM del ginocchio",
    "insertEx4": "Aggiungi questo contenuto prima di reperti",
    "insertSectionTitle": "Inserire sezione",
    "insertSectionDesc": "Crea una nuova sezione nel referto. Puoi indicare la posizione relativa a un'altra sezione.",
    "insertSectionEx1": "Inserisci una nuova sezione tecnica",
    "insertSectionEx2": "Aggiungi sezione note prima della conclusione",
    "selectTitle": "Selezionare opzioni",
    "selectDesc": "Quando il sistema mostra opzioni numerate, puoi selezionare, cambiare o cancellare opzioni specifiche per numero.",
    "selectEx1": "Seleziona l'uno e il due",
    "selectEx2": "Scegli da 1 a 4",
    "selectEx3": "Cambia il primo",
    "selectEx4": "Cancella il 4",
    "selectEx5": "Cambia tutti",
    "generateTitle": "Generare referto",
    "generateDesc": "Genera o rigenera il referto completo.",
    "generateEx1": "Genera referto",
    "dictationTitle": "Dettatura e punteggiatura",
    "dictationDesc": "Puoi dettare segni di punteggiatura e formattazione con la voce.",
    "dictationEx1": "punto → .",
    "dictationEx2": "virgola → ,",
    "dictationEx3": "due punti → :",
    "dictationEx4": "nuova riga → a capo",
    "dictationEx5": "nuovo paragrafo → interruzione di paragrafo",
    "tip": "💡 I comandi funzionano con prefissi opzionali come il nome dell'assistente (Carolina), espressioni di cortesia (per favore) o saluti informali (ciao). Tollerano anche la punteggiatura generata dal riconoscimento vocale."
  },
  "batch": {
    "title": "Dettatura in batch",
    "uploadSubtitle": "Carica un file audio con più referti",
    "transcribingSubtitle": "Trascrizione audio in corso...",
    "reviewSubtitle": "Rivedi e correggi gli studi rilevati",
    "generatingSubtitle": "Generazione referti in corso...",
    "stepUpload": "Carica audio",
    "stepReview": "Revisione",
    "transcriptionComplete": "Trascrizione completata — {{count}} studi rilevati",
    "transcriptionError": "Errore durante la trascrizione dell'audio",
    "noStudies": "Nessuno studio trovato. Assicurati di usare il formato [Paziente ID].",
    "batchSaved": "Lotto salvato con successo — {{count}} studi",
    "saveError": "Errore durante il salvataggio del lotto",
    "invalidFormat": "Formato non supportato. Usa file .wav, .mp3, .ogg o .webm",
    "durationExceeded": "La durata totale dei file audio non può superare i 30 minuti",
    "transcribingAudio": "Trascrizione audio in corso...",
    "transcribingHint": "L'audio è in fase di elaborazione. Potrebbe richiedere alcuni secondi.",
    "dropHere": "Rilascia il file qui",
    "uploadTitle": "Carica il tuo file audio",
    "uploadHint": "Trascina un file qui o clicca per selezionare",
    "supportedFormats": "Formati supportati: .wav, .mp3, .ogg, .webm",
    "useMockData": "Usa dati di esempio",
    "processAudio": "Elabora audio",
    "pause": "Pausa",
    "playAll": "Riproduci tutto",
    "unifiedHint": "Ogni studio è separato da [Paziente ID]. Premi ▶ accanto a ciascun paziente per ascoltare il segmento audio.",
    "studiesDetected": "{{count}} studi rilevati",
    "scrollToBottom": "Vai in fondo",
    "goToEnd": "Vai alla fine",
    "saving": "Salvataggio lotto...",
    "playSegment": "Riproduci segmento",
    "unifiedPlaceholder": "[Paziente 12345678]\nDescrittivo dello studio...\n\n[Paziente 87654321]\nAltro studio...",
    "generateAll": "Genera tutti"
  },
  "voiceCommands": {
    "noTextToDelete": "Nessun testo da eliminare specificato",
    "editorNotAvailable": "Editor non disponibile",
    "completeUpdatesBeforeDelete": "Completa o annulla gli aggiornamenti in sospeso prima di effettuare eliminazioni",
    "textNotFound": "\"{{text}}\" non trovato",
    "textNotFoundInDocument": "\"{{text}}\" non trovato nel documento",
    "couldNotDeleteText": "Impossibile eliminare il testo",
    "noPendingOperations": "Nessuna operazione in sospeso. Usa prima il comando DELETE, UPDATE o INSERT.",
    "noMatchesFound": "Nessuna corrispondenza contrassegnata trovata",
    "noIndicesSpecified": "Nessun indice specificato",
    "invalidIndices": "Indici non validi: {{indices}}. Intervallo valido: 1-{{max}}",
    "noMatchesForIndices": "Nessuna corrispondenza trovata per gli indici specificati",
    "noMatchesForIndicesDetail": "Nessuna corrispondenza trovata per gli indici specificati: {{indices}}",
    "noTextToUpdate": "Nessun testo da aggiornare specificato",
    "noReplacementText": "Nessun testo sostitutivo specificato",
    "completeDeletesBeforeUpdate": "Completa o annulla le eliminazioni in sospeso prima di effettuare aggiornamenti",
    "couldNotUpdateText": "Impossibile aggiornare il testo",
    "updateExtensionNotAvailable": "L'estensione di aggiornamento non è disponibile",
    "noMarkedElements": "Nessun elemento contrassegnato trovato nel documento",
    "noPendingOperationsSimple": "Nessuna operazione in sospeso",
    "couldNotFindInsertPosition": "Impossibile trovare la posizione di inserimento",
    "noContentToInsert": "Nessun contenuto da inserire",
    "noReferenceText": "Nessun testo di riferimento specificato",
    "completeDeletesBeforeInsert": "Completa o annulla le eliminazioni in sospeso prima di effettuare inserimenti",
    "completeUpdatesBeforeInsert": "Completa o annulla gli aggiornamenti in sospeso prima di effettuare inserimenti",
    "insertExtensionNotAvailable": "L'estensione di inserimento non è disponibile",
    "couldNotGenerateReport": "Impossibile generare il rapporto",
    "textInsertedInReport": "Testo inserito nel rapporto",
    "textInsertedInDescription": "Testo inserito nella descrizione",
    "textInsertedAtEndOfReport": "Testo inserito alla fine del rapporto",
    "textUpdated": "Testo aggiornato",
    "textDeleted": "Testo eliminato",
    "matchesFoundClickToUpdate": "{{count}} corrispondenze trovate. Clicca sul testo sottolineato per aggiornarlo.",
    "matchesFoundUseSelect": "{{count}} corrispondenze trovate. Usa 'seleziona' per scegliere quali eliminare.",
    "matchesDeleted": "{{count}} corrispondenza/e eliminata/e",
    "matchesUpdated": "{{count}} corrispondenza/e aggiornata/e",
    "couldNotProcessDeletions": "Impossibile elaborare le eliminazioni",
    "couldNotProcessUpdates": "Impossibile elaborare gli aggiornamenti",
    "generateReportOnlyFromDescription": "Il comando genera rapporto funziona solo dalla descrizione o con indici",
    "generatingReport": "Generazione rapporto...",
    "voiceInputProcessingError": "Errore nell'elaborazione dell'input vocale",
    "deleteExtensionNotAvailable": "L'estensione di eliminazione non è disponibile",
    "textNotFoundInValidSection": "\"{{text}}\" non trovato in una sezione valida",
    "textNotFoundForInsert": "\"{{text}}\" non trovato per l'inserimento",
    "noSectionSpecified": "Nessuna sezione specificata",
    "sectionNotFound": "Sezione \"{{section}}\" non trovata",
    "textNotFoundInSection": "\"{{text}}\" non trovato nella sezione \"{{section}}\"",
    "sectionTitleRequired": "È necessario un titolo per la sezione",
    "referenceSectionRequired": "È necessario specificare la sezione di riferimento",
    "cannotAddSection": "Impossibile aggiungere la sezione",
    "couldNotInsertSection": "Impossibile inserire la sezione",
    "errorInsertingSection": "Errore nell'inserimento della sezione",
    "couldNotDetermineInsertPosition": "Impossibile determinare la posizione di inserimento in \"{{section}}\"",
    "errorInsertingTextInSection": "Errore nell'inserimento del testo nella sezione",
    "noCommandRecognized": "Nessun comando riconosciuto"
  },
  "share": {
    "me": "Io",
    "sharedWith": "Condiviso con",
    "title": "Condividi bozza",
    "tabUsers": "Persone",
    "tabLink": "Collegamento",
    "searchUser": "Cerca per nome o email...",
    "userAdded": "Utente aggiunto con successo",
    "cannotShareSelf": "Non puoi condividere con te stesso",
    "differentAccount": "Puoi condividere solo con utenti del tuo account",
    "errorSharing": "Errore durante la condivisione",
    "userRemoved": "Accesso revocato",
    "errorRemoving": "Errore durante la revoca dell'accesso",
    "errorUpdating": "Errore nell'aggiornamento delle autorizzazioni",
    "linkEnabled": "Collegamento attivato",
    "errorLink": "Errore nell'aggiornamento del collegamento",
    "linkCopied": "Collegamento copiato negli appunti",
    "errorCopyLink": "Errore durante la copia del collegamento",
    "tokenRegenerated": "Collegamento rigenerato",
    "errorRegenerate": "Errore durante la rigenerazione del collegamento",
    "owner": "Proprietario",
    "addedBy": "Aggiunto da",
    "permView": "Visualizza",
    "permEdit": "Modifica",
    "targetNotFound": "Utente con cui condividere non trovato",
    "linkInvalid": "Collegamento non valido o disattivato",
    "linkOtherAccount": "Questo collegamento appartiene a un altro account e non può essere aperto",
    "joinError": "Errore durante l'accesso alla bozza condivisa",
    "goToReports": "Vai ai referti",
    "joining": "Apertura della bozza condivisa...",
    "noUsersFound": "Nessun utente trovato",
    "noUsersShared": "Non ancora condiviso con nessuno",
    "shareLinkTitle": "Condividi per collegamento",
    "shareLinkDesc": "Chiunque abbia il collegamento può accedere",
    "linkPermission": "Autorizzazione collegamento",
    "removeAccess": "Revoca accesso",
    "addUser": "Condividi",
    "copy": "Copia",
    "copyLink": "Copia collegamento",
    "errorUpdatingLink": "Errore durante l'aggiornamento del collegamento"
  },
  "collaboration": {
    "connected": "In diretta",
    "connecting": "Connessione...",
    "invite": "Invita",
    "inviteMore": "Invita altre persone"
  },
  "workHistory": {
    "title": "Cronologia di lavoro",
    "subtitle": "Cronologia di lavoro",
    "sent": "Inviati",
    "drafts": "Bozze",
    "empty": "Nessun referto in questa sezione.",
    "error": "Impossibile caricare la cronologia."
  },
  "groupReports": {
    "exportFileName": "cronologia_lavoro",
    "titlePrefix": "Cronologia di ",
    "titleAccent": "lavoro",
    "subtitle": "Referti inviati e bozze dei membri del gruppo.",
    "subtitleAccount": "Referti inviati e bozze dei membri dell'account.",
    "subtitleSelf": "I tuoi referti inviati e le tue bozze.",
    "kind": "Tipo di referto",
    "sent": "Inviati",
    "drafts": "Bozze",
    "author": "Autore",
    "allAuthors": "Tutto il gruppo",
    "scope": "Ambito",
    "scopeAccount": "Tutto l'account",
    "scopeSearch": "Cerca gruppo o persona…",
    "scopeExpand": "Mostra i membri del gruppo",
    "scopeNoMatches": "Nessuna corrispondenza.",
    "scopeEmptyGroup": "Gruppo senza utenti.",
    "search": "Cerca",
    "searchPlaceholder": "Cerca per titolo…",
    "from": "Dal",
    "to": "Al",
    "clearFilters": "Cancella filtri",
    "count": "{{count}} risultati",
    "searchModality": "Modalità…",
    "searchRegion": "Regione…",
    "modalities": "Modalità",
    "regions": "Regioni",
    "allTags": "Mostra tutte le etichette",
    "exportReports": "Scarica referti",
    "exportPreviewTitle": "Scarica referti",
    "exportPreviewSubtitle": "Anteprima del file Excel che verrà scaricato.",
    "exportSheetName": "storico_lavoro",
    "exportRowCount": "{{count}} righe",
    "exportMoreRows": "+ {{count}} righe in più nell'esportazione",
    "exportCol_title": "Titolo",
    "exportCol_author": "Autore",
    "exportCol_group": "Gruppo",
    "exportCol_date": "Data",
    "exportCol_modality": "Modalità",
    "exportCol_region": "Regione",
    "exportDownload": "Scarica Excel",
    "exportError": "Impossibile caricare i referti da esportare.",
    "exportErrorDownload": "Impossibile generare il file Excel.",
    "processingLabel": "{{count}} referto/i in elaborazione",
    "processingTooltip": "{{count}} referto/i in elaborazione. L'elenco si aggiornerà automaticamente al termine.",
    "untitled": "Senza titolo",
    "noMatches": "Nessun referto corrisponde ai filtri.",
    "empty": "Non ci sono ancora referti nel tuo gruppo.",
    "emptySelf": "Non hai ancora referti.",
    "error": "Impossibile caricare i referti del gruppo.",
    "errorSelf": "Impossibile caricare i tuoi referti."
  },
  "radiologistInsights": {
    "periodCustom": "Periodo personalizzato",
    "title": "Le tue metriche",
    "subtitle": "Attività di {{name}}",
    "groupFallbackName": "gruppo",
    "scopeLabel": "Ambito delle statistiche",
    "scopePersonal": "Area personale",
    "scopeGroup": "Area del gruppo",
    "groupPlaceholderTitle": "Statistiche del gruppo",
    "groupPlaceholderText": "Le statistiche aggregate del gruppo saranno presto disponibili.",
    "correlationTitle": "Attività congiunta dei radiologi",
    "correlationSubtitle": "Attività congiunta rispetto al radiologo con più referti nel gruppo (0–1)",
    "correlationPairCount": "{{count}} confronti",
    "correlationPairOne": "1 confronto",
    "correlationNoPairs": "Servono almeno due radiologi per confrontare la loro attività.",
    "correlationError": "Impossibile caricare i radiologi del gruppo.",
    "correlationEmpty": "Non ci sono radiologi nel gruppo.",
    "groupError": "Impossibile caricare le statistiche del gruppo.",
    "groupOverviewSection": "Panoramica del gruppo",
    "groupRadiologistsSection": "Radiologi",
    "groupProductionTitle": "Produzione del gruppo",
    "groupProductionSubtitle": "{{total}} referti nel periodo selezionato",
    "groupModalityTitle": "Referti per modalità",
    "groupModalitySubtitle": "Distribuzione del gruppo",
    "topRadiologistsTitle": "Radiologi più produttivi",
    "topRadiologistsSubtitle": "Referti prodotti per radiologo",
    "timePerRadiologistTitle": "Tempo medio per radiologo",
    "timePerRadiologistSubtitle": "Minuti di modifica per referto",
    "snomedTooltip": "Tutti i reperti sono standardizzati utilizzando il codice internazionale SNOMED CT",
    "processingLabel": "{{count}} referto/i in elaborazione",
    "processingTooltip": "Ci sono {{count}} referto/i in elaborazione. I grafici si aggiorneranno automaticamente al termine.",
    "periodMonth": "Questo mese",
    "periodWeek": "Ultima settimana",
    "periodLast30": "Ultimi 30 giorni",
    "periodDay": "Oggi",
    "kpi": {
      "reportsMonth": "Report questo mese",
      "reportsRange": "Report del periodo",
      "vsPrevRange": "vs periodo precedente",
      "reportsWeek": "Report questa settimana",
      "reportsDay": "Report oggi",
      "reportsLast30": "Report ultimi 30g",
      "vsLastMonth": "vs mese scorso",
      "vsLastWeek": "vs settimana scorsa",
      "vsYesterday": "vs ieri",
      "vsPrev30": "vs 30 giorni precedenti",
      "topModality": "La tua modalità principale",
      "topRegion": "La tua regione principale",
      "reportsCount": "{{count}} report",
      "percentOfTotal": "{{percent}}% del totale",
      "findingsPerReport": "Riscontri per report",
      "billing": "Fatturazione",
      "accumulated": "Accumulato mensile",
      "topRadiologist": "Radiologo con più referti",
      "groupTotalReports": "Referti del gruppo",
      "thisMonth": "questo mese",
      "activeRadiologists": "Radiologi attivi",
      "inTheGroup": "nel gruppo",
      "groupAvgEditTime": "Tempo medio di modifica",
      "perReport": "per referto"
    },
    "reportsPerDay": "Report al giorno",
    "dailyAverage": "La tua media giornaliera: {{average}} report",
    "reports": "report",
    "dayLabel": "Giorno {{day}}",
    "today": "oggi",
    "average": "media",
    "modalities": "Le tue modalità",
    "periodDistribution": "Distribuzione del periodo",
    "noData": "Nessun dato",
    "frequentFindings": "Riscontri più frequenti",
    "seeAll": "Vedi tutti →",
    "inYourReports": "Nei tuoi report · {{total}} menzioni totali",
    "findingsBy": "Riscontri per",
    "searchModality": "Cerca modalità...",
    "searchRegion": "Cerca regione...",
    "noFindingsForFilters": "Nessun riscontro per questi filtri nel periodo.",
    "filter": "Filtra:",
    "yourReportsCount": "{{count}} tuoi report",
    "billing": "La tua fatturazione",
    "billingMeta": "{{range}} · <strong>{{accumulated}}</strong> accumulato · proiezione fine mese {{projection}}",
    "billingMetaWeek": "{{range}} · <strong>{{accumulated}}</strong> accumulato · proiezione fine settimana {{projection}}",
    "billingMetaDay": "{{range}} · <strong>{{accumulated}}</strong> accumulato oggi",
    "billingMetaLast30": "{{range}} · <strong>{{accumulated}}</strong> accumulato negli ultimi 30 giorni",
    "billingDaily": "Entrate giornaliere",
    "billingDailySubtitle": "Quanto hai fatturato in ogni giornata del periodo",
    "editTimeSection": "Tempo di modifica",
    "reportsSection": "Report",
    "findingsSection": "Riscontri",
    "billingSection": "Fatturazione",
    "editTimeAvgCard": "Tempo medio per report",
    "editTimeCardSub": "{{reports}} report · {{total}} totale",
    "editTimeEmpty": "Nessun dato di modifica per questo periodo",
    "editTimeMedianCard": "Mediana per report",
    "editTimeMedianSub": "Valore centrale di {{reports}} report",
    "editTimeLastCard": "Ultimo report",
    "editTimeLastSub": "Tempo del report più recente",
    "editTime": "Tempo dedicato al giorno",
    "editTimeAvg": "Media per report: {{average}} · Totale: {{total}} in {{reports}} report",
    "editTimeLabel": "tempo",
    "presave": {
      "sectionTitle": "Inconsistenze e avvisi",
      "overrideRate": "Tasso di invii forzati",
      "overrideTrendTooltip": "Variazione rispetto al periodo precedente (punti percentuale)",
      "overrideSub": "{{count}} decisioni",
      "totalWarnings": "Avvisi del gruppo",
      "totalSub": "{{forced}} inviati comunque",
      "warningsPerReport": "Inconsistenze per report",
      "perReport": "densità",
      "topOverride": "Tasso di invii forzati più alto",
      "topOverrideSub": "{{pct}} % · {{forced}} inviati comunque",
      "timelineTitle": "Inconsistenze per giorno",
      "timelineSubtitle": "Suddivisione giornaliera tra Revisionare (verde) e Inviare comunque (rosso)",
      "splitTitle": "Suddivisione delle decisioni",
      "splitSubtitle": "Quota di invii forzati sul totale deciso",
      "radiologistsTitle": "Tasso di inconsistenze non risolte per radiologo",
      "radiologistsSubtitle": "% di avvisi inviati comunque sul totale deciso",
      "radiologistsVolumeTitle": "Radiologi con più inconsistenze",
      "radiologistsVolumeSubtitle": "Totale avvisi emessi da ciascun radiologo del gruppo",
      "templatesTitle": "Modelli con più avvisi",
      "templatesSubtitle": "Procedure in cui ha origine l'inconsistenza",
      "listTitle": "Eventi di inconsistenze",
      "listMeta": "{{total}} avvisi",
      "colDate": "Data",
      "colRadiologist": "Radiologo",
      "colJustification": "Giustificazione",
      "colDecision": "Decisione",
      "review": "Revisionare",
      "forceSend": "Inviare comunque",
      "pending": "In attesa",
      "override": "Forzati",
      "empty": "Nessun avviso nel periodo selezionato.",
      "loadMore": "Carica altri ({{remaining}} restanti)",
      "collapse": "Comprimi"
    }
  },
  "voice": {
    "recoveryTitle": "Registrazione non elaborata",
    "recoveryDescription": "Non è stato possibile elaborare la registrazione dopo diversi tentativi. Puoi riprovare o eliminare la registrazione.",
    "recoveryRetry": "Riprova",
    "recoveryDownload": "Scarica audio",
    "recoveryDiscard": "Elimina",
    "recoveryConfirmDiscard": "Sei sicuro? Clicca di nuovo",
    "hardLimitReached": "Limite massimo di registrazione raggiunto (1h 30m). L'audio è in fase di elaborazione.",
    "importBusy": "Termina o annulla la dettatura in corso prima di importare un audio.",
    "importMultipleFiles": "Rilascia un solo file audio.",
    "importUnsupportedType": "Sono supportati solo file audio.",
    "importTooLarge": "Il file supera il limite di {{maxMb}} MB.",
    "importTooLong": "L'audio supera il limite di {{maxMin}} minuti.",
    "importDecodeFailed": "Impossibile leggere l'audio. Prova con un altro formato.",
    "importNoVoice": "Nessuna voce rilevata nell'audio importato.",
    "importNoEncoder": "Questo browser non può preparare l'audio importato. Aggiornalo o usa un altro browser.",
    "importError": "Impossibile preparare l'audio importato.",
    "importComposeFailed": "Impossibile unire l'audio. La dettatura resta in pausa: inviala di nuovo.",
    "importPreparing": "Preparazione dell'audio…",
    "importDropHint": "Rilascia l'audio per caricarlo",
    "softLimitWarning": "La registrazione dura da più di 10 minuti",
    "errorTimeout": "Il server ha impiegato troppo tempo. Il tuo audio è salvato, puoi riprovare.",
    "errorDisconnected": "Connessione al server persa. Il tuo audio è salvato.",
    "generationInProgress": "C'è già una generazione in corso. Attendi che finisca.",
    "errorAfterApplied": "La generazione è terminata con un errore. Controlla il contenuto applicato al referto.",
    "errorGeneration": "Errore nella generazione del referto. Il tuo audio è salvato, puoi riprovare.",
    "errorGeneric": "Errore nell'elaborazione dell'audio. Il tuo audio è salvato.",
    "audioSaved": "Audio ricevuto",
    "templateNotFound": "Modello \"{{templateName}}\" non trovato.",
    "processingDictation": "Elaborazione dettatura…",
    "holdCancel": "Annulla",
    "holdLock": "Blocca",
    "holdSend": "Invia",
    "traditionalDictation": "Dettatura tradizionale",
    "holdRightClickHint": "Tieni premuto per dettare"
  },
  "micPage": {
    "title": "Microfono del telefono",
    "connecting": "Connessione…",
    "needPermission": "Devi consentire il microfono sul telefono prima di registrare. Tocca per consentirlo.",
    "allowMic": "Consenti microfono",
    "retryMic": "Riprova il permesso del microfono",
    "permissionBlocked": "L'accesso al microfono è stato negato. Attivalo nelle impostazioni del browser del telefono e tocca di nuovo.",
    "micNotFound": "Nessun microfono rilevato su questo telefono.",
    "micBusy": "Un'altra app sta usando il microfono. Chiudila e riprova.",
    "micUnavailable": "Impossibile accedere al microfono del telefono. Tocca di nuovo per riprovare.",
    "ready": "Pronto. Tocca il pulsante per registrare.",
    "waitingDesktop": "In attesa del desktop…",
    "recording": "Registrazione…",
    "paused": "In pausa",
    "processing": "Elaborazione audio…",
    "processingHint": "Silero sta rimuovendo i silenzi…",
    "record": "Registra",
    "pause": "Pausa",
    "resume": "Riprendi",
    "stop": "Invia",
    "cancel": "Annulla",
    "desktopConnected": "Desktop connesso",
    "desktopWaiting": "Desktop non connesso",
    "desktopBusy": "Il desktop sta registrando. Attendi che finisca.",
    "missingToken": "Manca il link di accoppiamento. Scansiona di nuovo il QR.",
    "invalidToken": "Il link non è valido. Genera un altro codice sul desktop.",
    "expiredToken": "Il codice è scaduto. Generane un altro sul desktop.",
    "roomFull": "Un telefono è già collegato a questo codice.",
    "permissionDenied": "Impossibile accedere al microfono. Controlla l'autorizzazione del browser.",
    "insecureOrigin": "Il microfono richiede HTTPS (o localhost).",
    "disconnected": "Connessione con il desktop persa.",
    "helloTimeout": "Impossibile unirsi alla stanza. Riprova.",
    "idle": "La stanza è stata chiusa per inattività.",
    "recordingLimit": "È stato raggiunto il limite di registrazione.",
    "relayError": "Impossibile connettersi. Genera un altro codice sul desktop."
  },
  "orgAdmin": {
    "backToApp": "Torna ad Ainovis",
    "loadError": "Impossibile caricare le informazioni.",
    "saveError": "Impossibile salvare. Controlla i dati e riprova.",
    "comingSoon": "Prossimamente",
    "shell": {
      "eyebrow": "Amministrazione",
      "pageTitlePrefix": "Pannello di ",
      "pageTitleAccent": "amministrazione",
      "pageSubtitle": "Gestisci tutto l'account {{name}}",
      "meta": "{{groups}} gruppi · {{users}} utenti"
    },
    "rail": {
      "title": "Account",
      "groups": "Gruppi",
      "account": "Tutto l'account",
      "accountPicker": "Account",
      "emptyAccount": "Non ci sono ancora gruppi. Aggiungi il primo",
      "usersTooltip": "Utenti del gruppo"
    },
    "confirm": {
      "deleteGroupHint": "I suoi utenti resteranno senza gruppo assegnato. L'operazione non è reversibile.",
      "irreversible": "Questa operazione non è reversibile."
    },
    "nav": {
      "overview": "Panoramica",
      "stats": "Statistiche",
      "groups": "Gruppi",
      "users": "Utenti",
      "templates": "Modelli",
      "settings": "Permessi"
    },
    "period": {
      "month": "Mese",
      "week": "Settimana",
      "day": "Giorno",
      "last30": "Ultimi 30 giorni"
    },
    "overview": {
      "title": "Panoramica",
      "subtitle": "Attività di {{name}}",
      "reports": "Referti",
      "activeUsers": "Utenti attivi",
      "avgEdit": "Tempo medio di modifica",
      "topUser": "Utente in evidenza",
      "reportsCount": "{{count}} referti",
      "activity": "Attività",
      "contact": "Dati di contatto",
      "noContact": "Nessun dato di contatto.",
      "parent": "Account",
      "shortcuts": "Vai a",
      "groupsTitle": "Gruppi",
      "topGroup": "Gruppo con più referti",
      "fastestGroup": "Gruppo più rapido"
    },
    "groups": {
      "title": "Gruppi",
      "subtitle": "Gruppi dell'account",
      "addGroup": "Aggiungi gruppo",
      "emptyGroups": "Questo account non ha ancora gruppi.",
      "usersCount": "{{active}}/{{count}} utenti",
      "deleteGroupConfirm": "Eliminare il gruppo {{name}}?",
      "editGroup": "Modifica gruppo"
    },
    "form": {
      "name": "Nome",
      "surname": "Cognome",
      "nationalId": "P. IVA",
      "nameRequired": "Il nome è obbligatorio.",
      "address": "Indirizzo",
      "professionalTitle": "Titolo professionale (facoltativo)",
      "email": "Email",
      "phone": "Telefono",
      "namePlaceholder": "Es: Maria",
      "surnamePlaceholder": "Es: Rossi Bianchi",
      "emailPlaceholder": "Es: maria@ospedale.com",
      "nationalIdPlaceholder": "Es: 12345678A",
      "addressPlaceholder": "Es: Via Roma 1, Milano",
      "professionalTitlePlaceholder": "Dott., Dott.ssa, ...",
      "phonePlaceholder": "Es: +39 02 1234 5678"
    },
    "users": {
      "title": "Utenti",
      "searchPlaceholder": "Cerca per nome o email",
      "allRoles": "Tutti i ruoli",
      "allStatuses": "Tutti gli stati",
      "filters": "Filtri",
      "columnUser": "Utente",
      "columnRole": "Ruolo",
      "columnGroup": "Gruppo",
      "columnStatus": "Stato",
      "statusActive": "Attivo",
      "statusPending": "In attesa",
      "statusInactive": "Inattivo",
      "noGroup": "Senza gruppo",
      "count": "{{count}} utenti",
      "empty": "Questo account non ha ancora utenti.",
      "emptyFiltered": "Nessun utente corrisponde ai filtri.",
      "selected": "{{count}} selezionati",
      "selectAll": "Seleziona tutti",
      "bulkLabel": "Modelli personali:",
      "bulkDone": "{{count}} utenti aggiornati.",
      "bulkPartial": "Non è stato possibile aggiornare {{count}} utenti.",
      "columnActions": "Azioni",
      "add": "Aggiungi utente",
      "addHint": "Riceverà un'email per verificare l'account e scegliere la password.",
      "sendInvite": "Crea e invita",
      "createOnly": "Crea senza invitare",
      "edit": "Modifica utente",
      "editHint": "Ruolo e gruppo si cambiano dalla tabella.",
      "emailLocked": "L'email di accesso non può essere modificata.",
      "updated": "Utente aggiornato.",
      "formRequired": "Compila tutti i campi obbligatori.",
      "resend": "Reinvia invito",
      "activate": "Attiva",
      "deactivate": "Disattiva",
      "activated": "Utente attivato.",
      "deactivated": "Utente disattivato.",
      "roleChanged": "Ruolo aggiornato.",
      "groupChanged": "Utente spostato di gruppo.",
      "inviteSent": "Invito inviato.",
      "deleted": "Utente eliminato.",
      "deleteTitle": "Eliminare {{name}}?",
      "deleteHint": "Vengono eliminati anche bozze, modelli e impostazioni.",
      "loadMore": "Carica altri ({{remaining}} rimanenti)",
      "endOfList": "Non ci sono altri utenti.",
      "page": "Pagina {{page}} di {{totalPages}}",
      "loadError": "Non è stato possibile caricare gli utenti.",
      "accessTitle": "Accesso e permessi",
      "accessSelfHint": "Non puoi modificare il tuo ruolo né i tuoi permessi."
    },
    "templates": {
      "title": "Modelli",
      "total": "{{count}} modelli",
      "upload": "Carica",
      "uploadScope": "Ambito",
      "uploadScopePlaceholder": "Scegli un ambito…",
      "scopeEverything": "Account e gruppi",
      "scopeAll": "{{name}}",
      "scopeOnlyAccount": "Solo l'account",
      "hintAll": "{{total}} modelli in {{count}} gruppi",
      "hintAccount": "Visibile ai {{count}} gruppi dell'account {{name}} · {{total}} modelli",
      "hintGroup": "Visibile solo al team di {{name}} · {{total}} modelli",
      "searchPlaceholder": "Cerca modello",
      "selected": "{{count}} selezionati",
      "moveTo": "Sposta in",
      "edit": "Modifica modello",
      "select": "Seleziona {{name}}",
      "page": "Pagina {{page}} di {{totalPages}}",
      "emptyAccount": "Questo account non ha ancora modelli istituzionali.",
      "emptyGroup": "Questo gruppo non ha modelli propri.",
      "emptyGroupHint": "Vede comunque i {{count}} dell'account {{name}}.",
      "emptyFiltered": "Nessun modello corrisponde alla ricerca.",
      "confirmDelete": "Eliminare {{count}} modelli? L'operazione non è reversibile.",
      "confirmPromote": "Stai per rendere {{count}} modelli visibili ai {{groups}} gruppi dell'account {{name}}.",
      "loadError": "Non è stato possibile caricare i modelli.",
      "moveError": "Non è stato possibile spostare i modelli.",
      "languageError": "Non è stato possibile cambiare la lingua del modello.",
      "deleteError": "Non è stato possibile eliminare i modelli.",
      "processing": "Salvataggio",
      "processingHint": "Questo modello è già stato salvato. È ancora in preparazione per la dettatura e non può essere rilevato automaticamente finché non è pronto."
    },
    "scope": {
      "account": "Tutto l'account",
      "group": "Gruppo"
    },
    "settings": {
      "title": "Impostazioni",
      "applyNote": "Sovrascrive la policy dei {{count}} gruppi esistenti con i valori qui sopra."
    },
    "policy": {
      "title": "Policy dei modelli",
      "groupNote": "Si applica agli utenti di questo gruppo senza permessi personalizzati.",
      "personalTitle": "Modelli personali",
      "personalHint": "Consente ai radiologi di usare, creare e modificare i propri modelli e blocchi. Disattivandolo spariscono anche i modelli personali già esistenti.",
      "ainovisTitle": "Modelli Ainovis",
      "ainovisHint": "Consente di accedere ai modelli Ainovis. Se disattivato, non saranno più disponibili nell'app.",
      "institutionalTitle": "Modelli istituzionali",
      "institutionalHint": "Consente di accedere ai modelli del gruppo e dell'account. Se disattivato, non saranno più disponibili nell'app.",
      "allowed": "Consentito",
      "blocked": "Bloccato",
      "inherit": "Ereditato dal gruppo ({{state}})",
      "inheritShort": "Ereditato dal gruppo",
      "groupPolicy": "Ereditato dal gruppo",
      "legend": "Consentito / Bloccato / Ereditato dal gruppo: cosa significa ciascun valore.",
      "legendAllowed": "questa persona può sempre usarlo, anche se il suo gruppo lo vieta.",
      "legendBlocked": "questa persona non può mai usarlo, anche se il suo gruppo lo consente.",
      "legendGroup": "questa persona non ha una propria impostazione; si applica la decisione del suo gruppo (mostrata accanto).",
      "legendNoGroup": "questa persona non ha un gruppo assegnato; si applica la politica predefinita dell'account.",
      "alwaysAllowed": "Sempre consentito",
      "exemptHint": "Gli amministratori possono sempre creare modelli.",
      "saved": "Policy aggiornata.",
      "defaultsTitle": "Permessi dei modelli",
      "defaultsWarning": "Questi permessi si applicano ai nuovi gruppi. I gruppi esistenti non vengono modificati.",
      "applyToGroups": "Applica i permessi ai gruppi esistenti",
      "applyConfirm": "La policy di tutti i gruppi dell'account verrà sovrascritta. Continuare?",
      "applied": "Applicato a {{count}} gruppi."
    },
    "classifications": {
      "title": "Politica delle classificazioni",
      "note": "Decidi chi può usare le classificazioni in questo account e quali scale sono disponibili.",
      "groupNote": "Ciò che si applica agli utenti di questo gruppo, salvo permesso proprio.",
      "defaultsWarning": "Valori iniziali dei nuovi gruppi. I gruppi esistenti mantengono i propri.",
      "userTitle": "Classificazioni",
      "userHint": "Consente a questa persona di usare le classificazioni, a prescindere dal suo gruppo.",
      "scalesTitle": "Classificazioni disponibili",
      "scalesCount": "{{active}} di {{total}} attive",
      "scalesUserTitle": "Scegliere una a una",
      "scalesUserHint": "Eccezioni per questa persona; ciò che non si tocca segue il gruppo.",
      "audienceTitle": "Chi può classificare",
      "saved": "Politica delle classificazioni aggiornata.",
      "audience": {
        "nobody": "Nessuno",
        "admins": "Solo amministratori",
        "everyone": "Tutto l'account"
      },
      "audienceDesc": {
        "nobody": "Nessuno nell'account può classificare.",
        "admins": "Comportamento attuale: solo gli amministratori possono classificare.",
        "everyone": "Qualsiasi utente dell'account può classificare."
      },
      "hints": {
        "FLEISCHNER": "Nodulo polmonare",
        "TI-RADS": "Tiroide",
        "PI-RADS": "Prostata",
        "BOSNIAK_2019": "Cisti renale",
        "GARDEN": "Frattura dell'anca",
        "EATON_LITTLER": "Rizartrosi (mano)",
        "SNYDER": "Cuffia dei rotatori (spalla)",
        "HERBERT_FISCHER": "Frattura dello scafoide (polso)"
      }
    },
    "permissions": {
      "column": "Permessi",
      "edit": "Modifica permessi",
      "title": "Permessi di {{name}}",
      "bulkTitle": "Permessi di {{count}} utenti",
      "bulkHint": "Le modifiche si applicano a tutti gli utenti selezionati.",
      "inherited": "Ereditati",
      "custom": "Personalizzati",
      "mixed": "Valori diversi",
      "partialExempt": "{{count}} degli utenti selezionati lo hanno sempre consentito."
    },
    "group": {
      "back": "Torna ai gruppi",
      "title": "Gruppo",
      "subtitle": "Attività e team del gruppo",
      "team": "Team",
      "emptyTeam": "Questo gruppo non ha ancora utenti.",
      "active": "Attivo",
      "inactive": "Inattivo"
    },
    "roles": {
      "user": "Utente",
      "admin": "Admin",
      "supervisor": "Supervisore",
      "super": "Super"
    }
  }
}
